/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const syncCompanies = /* GraphQL */ `
  query SyncCompanies(
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncCompanies(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        tenantId
        name
        email
        phone
        website
        registrationNumber
        vatNumber
        addressLine1
        addressLine2
        logoImage {
          bucket
          region
          key
          identityId
        }
        invoiceCount
        purchaseOrderInvoiceCount
        invoicingYear
        bank
        iban
        bic
        accountName
        bankProfileName
        bankProfileName2
        bank2
        iban2
        bic2
        accountName2
        bankProfileName3
        bank3
        iban3
        bic3
        accountName3
        duplicateQuoteCounter
        companyEmailId
        companyInvoices {
          bucket
          region
          key
          identityId
          fileName
          fileType
          fromEmailId
          thumbnailBucket
          thumbnailRegion
          thumbnailKey
          thumbnailIdentityId
        }
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getCompany = /* GraphQL */ `
  query GetCompany($id: ID!) {
    getCompany(id: $id) {
      id
      tenantId
      name
      email
      phone
      website
      registrationNumber
      vatNumber
      addressLine1
      addressLine2
      logoImage {
        bucket
        region
        key
        identityId
      }
      invoiceCount
      purchaseOrderInvoiceCount
      invoicingYear
      bank
      iban
      bic
      accountName
      bankProfileName
      bankProfileName2
      bank2
      iban2
      bic2
      accountName2
      bankProfileName3
      bank3
      iban3
      bic3
      accountName3
      duplicateQuoteCounter
      companyEmailId
      companyInvoices {
        bucket
        region
        key
        identityId
        fileName
        fileType
        fromEmailId
        thumbnailBucket
        thumbnailRegion
        thumbnailKey
        thumbnailIdentityId
      }
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const listCompanys = /* GraphQL */ `
  query ListCompanys(
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompanys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        tenantId
        name
        email
        phone
        website
        registrationNumber
        vatNumber
        addressLine1
        addressLine2
        logoImage {
          bucket
          region
          key
          identityId
        }
        invoiceCount
        purchaseOrderInvoiceCount
        invoicingYear
        bank
        iban
        bic
        accountName
        bankProfileName
        bankProfileName2
        bank2
        iban2
        bic2
        accountName2
        bankProfileName3
        bank3
        iban3
        bic3
        accountName3
        duplicateQuoteCounter
        companyEmailId
        companyInvoices {
          bucket
          region
          key
          identityId
          fileName
          fileType
          fromEmailId
          thumbnailBucket
          thumbnailRegion
          thumbnailKey
          thumbnailIdentityId
        }
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncUserInfos = /* GraphQL */ `
  query SyncUserInfos(
    $filter: ModelUserInfoFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncUserInfos(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        email
        firstName
        lastName
        phone
        tenantId
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
      }
      nextToken
      startedAt
    }
  }
`;
export const getUserInfo = /* GraphQL */ `
  query GetUserInfo($id: ID!) {
    getUserInfo(id: $id) {
      id
      email
      firstName
      lastName
      phone
      tenantId
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listUserInfos = /* GraphQL */ `
  query ListUserInfos(
    $filter: ModelUserInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserInfos(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        email
        firstName
        lastName
        phone
        tenantId
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
      }
      nextToken
      startedAt
    }
  }
`;
export const syncFreelancers = /* GraphQL */ `
  query SyncFreelancers(
    $filter: ModelFreelancersFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncFreelancers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        email
        name
        freelancerTenantId
        companyTenantId
        profileImage {
          bucket
          region
          key
          identityId
        }
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getFreelancers = /* GraphQL */ `
  query GetFreelancers($id: ID!) {
    getFreelancers(id: $id) {
      id
      email
      name
      freelancerTenantId
      companyTenantId
      profileImage {
        bucket
        region
        key
        identityId
      }
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const listFreelancerss = /* GraphQL */ `
  query ListFreelancerss(
    $filter: ModelFreelancersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFreelancerss(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        email
        name
        freelancerTenantId
        companyTenantId
        profileImage {
          bucket
          region
          key
          identityId
        }
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncContacts = /* GraphQL */ `
  query SyncContacts(
    $filter: ModelContactFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncContacts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        tenantId
        activeFlag
        name
        idnumber
        vatNumber
        website
        phone
        firstName
        lastName
        email
        contactPhone
        line01
        line02
        city
        state
        postalCode
        country
        currency
        paymentTerms
        taxType
        taxRate
        note
        bank
        iban
        bic
        accountName
        invoices {
          items {
            id
            tenantId
            proposalId
            activeFlag
            originalInvoiceId
            creditInvoiceGenerated
            archivedDate
            paidDate
            paymentStatus
            quoteName
            projectName
            clientId
            clientName
            contactName
            clientTaxType
            clientEmail
            clientAddress
            clientIdNumber
            clientVatNumber
            clientCurrency
            clientTaxRate
            title
            invoiceNumber
            poNumber
            invoiceAmountPercentage
            amount
            amountAfterTax
            taxAmount
            balancePercentage
            balanceAmount
            clientNote
            isDetailed
            bankProfileNumber
            invoicesBankProfileName
            invoicesBank
            invoicesIban
            invoicesBic
            invoicesAccountName
            invoiceDate
            invoiceDueDate
            description
            creditComments
            invoiceType
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
        _version
        _deleted
        _lastChangedAt
        createdOn
        updatedOn
      }
      nextToken
      startedAt
    }
  }
`;
export const getContact = /* GraphQL */ `
  query GetContact($id: ID!) {
    getContact(id: $id) {
      id
      tenantId
      activeFlag
      name
      idnumber
      vatNumber
      website
      phone
      firstName
      lastName
      email
      contactPhone
      line01
      line02
      city
      state
      postalCode
      country
      currency
      paymentTerms
      taxType
      taxRate
      note
      bank
      iban
      bic
      accountName
      invoices {
        items {
          id
          tenantId
          proposalId
          activeFlag
          originalInvoiceId
          creditInvoiceGenerated
          archivedDate
          paidDate
          paymentStatus
          quoteName
          projectName
          clientId
          clientName
          contactName
          clientTaxType
          clientEmail
          clientAddress
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          title
          invoiceNumber
          poNumber
          invoiceAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          clientNote
          isDetailed
          bankProfileNumber
          invoicesBankProfileName
          invoicesBank
          invoicesIban
          invoicesBic
          invoicesAccountName
          invoiceDate
          invoiceDueDate
          description
          creditComments
          invoiceType
          proposalsDraft {
            generated
            poNumber
            proposalAmountPercentage
            amount
            amountAfterTax
            taxAmount
            balancePercentage
            balanceAmount
            invoiceId
            invoiceDate
            invoiceDueDate
            description
            readyStatus
          }
          proposals {
            id
            tenantId
            activeFlag
            quoteId
            clientId
            status
            noofInvoices
            quoteName
            projectName
            clientTaxType
            clientName
            contactName
            clientEmail
            clientAddress
            clientIdNumber
            clientVatNumber
            clientCurrency
            clientTaxRate
            paymentTerms
            total
            clientNote
            isDetailed
            bankProfileNumber
            proposalsBankProfileName
            proposalsBank
            proposalsIban
            proposalsBic
            proposalsAccountName
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      _version
      _deleted
      _lastChangedAt
      createdOn
      updatedOn
    }
  }
`;
export const listContacts = /* GraphQL */ `
  query ListContacts(
    $filter: ModelContactFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listContacts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        tenantId
        activeFlag
        name
        idnumber
        vatNumber
        website
        phone
        firstName
        lastName
        email
        contactPhone
        line01
        line02
        city
        state
        postalCode
        country
        currency
        paymentTerms
        taxType
        taxRate
        note
        bank
        iban
        bic
        accountName
        invoices {
          items {
            id
            tenantId
            proposalId
            activeFlag
            originalInvoiceId
            creditInvoiceGenerated
            archivedDate
            paidDate
            paymentStatus
            quoteName
            projectName
            clientId
            clientName
            contactName
            clientTaxType
            clientEmail
            clientAddress
            clientIdNumber
            clientVatNumber
            clientCurrency
            clientTaxRate
            title
            invoiceNumber
            poNumber
            invoiceAmountPercentage
            amount
            amountAfterTax
            taxAmount
            balancePercentage
            balanceAmount
            clientNote
            isDetailed
            bankProfileNumber
            invoicesBankProfileName
            invoicesBank
            invoicesIban
            invoicesBic
            invoicesAccountName
            invoiceDate
            invoiceDueDate
            description
            creditComments
            invoiceType
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
        _version
        _deleted
        _lastChangedAt
        createdOn
        updatedOn
      }
      nextToken
      startedAt
    }
  }
`;
export const syncSuppliers = /* GraphQL */ `
  query SyncSuppliers(
    $filter: ModelSuppliersFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncSuppliers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        tenantId
        activeFlag
        name
        idnumber
        vatNumber
        website
        phone
        firstName
        lastName
        contactEmail
        companyEmail
        contactPhone
        line01
        line02
        city
        state
        postalCode
        country
        currency
        paymentTerms
        taxType
        taxRate
        note
        bank
        iban
        bic
        accountName
        commercialName
        supplierCreditorAccount
        supplierType
        individualType
        isArchived
        purchase {
          items {
            id
            tenantId
            activeFlag
            quoteId
            supplierId
            recapCostlineId
            quoteName
            projectName
            supplierName
            recapCostlineItem
            recapCostlineItem_fr
            provisionalTotal
            invoiceTotal
            taxAmount
            purchaseInvoiceDueDate
            purchaseArchivedDate
            purchasePaidDate
            supplierCreditorAccount
            purchaseOrderId
            poAvailable
            invoiceAvailable
            paymentStatus
            purchaseType
            supplierType
            invoiceKey
            _version
            _deleted
            _lastChangedAt
            createdOn
            updatedOn
          }
          nextToken
          startedAt
        }
        _version
        _deleted
        _lastChangedAt
        createdOn
        updatedOn
      }
      nextToken
      startedAt
    }
  }
`;
export const getSuppliers = /* GraphQL */ `
  query GetSuppliers($id: ID!) {
    getSuppliers(id: $id) {
      id
      tenantId
      activeFlag
      name
      idnumber
      vatNumber
      website
      phone
      firstName
      lastName
      contactEmail
      companyEmail
      contactPhone
      line01
      line02
      city
      state
      postalCode
      country
      currency
      paymentTerms
      taxType
      taxRate
      note
      bank
      iban
      bic
      accountName
      commercialName
      supplierCreditorAccount
      supplierType
      individualType
      isArchived
      purchase {
        items {
          id
          tenantId
          activeFlag
          quoteId
          supplierId
          recapCostlineId
          quoteName
          projectName
          supplierName
          recapCostlineItem
          recapCostlineItem_fr
          provisionalTotal
          invoiceTotal
          taxAmount
          purchaseInvoiceDueDate
          purchaseArchivedDate
          purchasePaidDate
          supplierCreditorAccount
          purchaseOrderId
          poAvailable
          invoiceAvailable
          paymentStatus
          purchaseType
          supplierType
          invoiceKey
          invoiceDocuments {
            bucket
            region
            key
            identityId
          }
          _version
          _deleted
          _lastChangedAt
          createdOn
          updatedOn
        }
        nextToken
        startedAt
      }
      _version
      _deleted
      _lastChangedAt
      createdOn
      updatedOn
    }
  }
`;
export const listSupplierss = /* GraphQL */ `
  query ListSupplierss(
    $filter: ModelSuppliersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSupplierss(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        tenantId
        activeFlag
        name
        idnumber
        vatNumber
        website
        phone
        firstName
        lastName
        contactEmail
        companyEmail
        contactPhone
        line01
        line02
        city
        state
        postalCode
        country
        currency
        paymentTerms
        taxType
        taxRate
        note
        bank
        iban
        bic
        accountName
        commercialName
        supplierCreditorAccount
        supplierType
        individualType
        isArchived
        purchase {
          items {
            id
            tenantId
            activeFlag
            quoteId
            supplierId
            recapCostlineId
            quoteName
            projectName
            supplierName
            recapCostlineItem
            recapCostlineItem_fr
            provisionalTotal
            invoiceTotal
            taxAmount
            purchaseInvoiceDueDate
            purchaseArchivedDate
            purchasePaidDate
            supplierCreditorAccount
            purchaseOrderId
            poAvailable
            invoiceAvailable
            paymentStatus
            purchaseType
            supplierType
            invoiceKey
            _version
            _deleted
            _lastChangedAt
            createdOn
            updatedOn
          }
          nextToken
          startedAt
        }
        _version
        _deleted
        _lastChangedAt
        createdOn
        updatedOn
      }
      nextToken
      startedAt
    }
  }
`;
export const syncPurchases = /* GraphQL */ `
  query SyncPurchases(
    $filter: ModelPurchaseFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncPurchases(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        tenantId
        activeFlag
        quoteId
        supplierId
        recapCostlineId
        quoteName
        projectName
        supplierName
        recapCostlineItem
        recapCostlineItem_fr
        provisionalTotal
        invoiceTotal
        taxAmount
        purchaseInvoiceDueDate
        purchaseArchivedDate
        purchasePaidDate
        supplierCreditorAccount
        purchaseOrderId
        poAvailable
        invoiceAvailable
        paymentStatus
        purchaseType
        supplierType
        invoiceKey
        invoiceDocuments {
          bucket
          region
          key
          identityId
        }
        _version
        _deleted
        _lastChangedAt
        createdOn
        updatedOn
      }
      nextToken
      startedAt
    }
  }
`;
export const getPurchase = /* GraphQL */ `
  query GetPurchase($id: ID!) {
    getPurchase(id: $id) {
      id
      tenantId
      activeFlag
      quoteId
      supplierId
      recapCostlineId
      quoteName
      projectName
      supplierName
      recapCostlineItem
      recapCostlineItem_fr
      provisionalTotal
      invoiceTotal
      taxAmount
      purchaseInvoiceDueDate
      purchaseArchivedDate
      purchasePaidDate
      supplierCreditorAccount
      purchaseOrderId
      poAvailable
      invoiceAvailable
      paymentStatus
      purchaseType
      supplierType
      invoiceKey
      invoiceDocuments {
        bucket
        region
        key
        identityId
      }
      _version
      _deleted
      _lastChangedAt
      createdOn
      updatedOn
    }
  }
`;
export const listPurchases = /* GraphQL */ `
  query ListPurchases(
    $filter: ModelPurchaseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPurchases(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        tenantId
        activeFlag
        quoteId
        supplierId
        recapCostlineId
        quoteName
        projectName
        supplierName
        recapCostlineItem
        recapCostlineItem_fr
        provisionalTotal
        invoiceTotal
        taxAmount
        purchaseInvoiceDueDate
        purchaseArchivedDate
        purchasePaidDate
        supplierCreditorAccount
        purchaseOrderId
        poAvailable
        invoiceAvailable
        paymentStatus
        purchaseType
        supplierType
        invoiceKey
        invoiceDocuments {
          bucket
          region
          key
          identityId
        }
        _version
        _deleted
        _lastChangedAt
        createdOn
        updatedOn
      }
      nextToken
      startedAt
    }
  }
`;
export const syncPurchaseOrders = /* GraphQL */ `
  query SyncPurchaseOrders(
    $filter: ModelPurchaseOrderFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncPurchaseOrders(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        tenantId
        activeFlag
        purchaseOrderNumber
        quoteId
        supplierId
        recapCostlineId
        costlineName
        costlineName_fr
        projectId
        poAvailable
        supplierName
        supplierTerms
        quantity
        number
        rate
        provisionalTotal
        taxRate
        deliveryDate
        deliveryAddress
        comments
        _version
        _deleted
        _lastChangedAt
        createdOn
        updatedOn
      }
      nextToken
      startedAt
    }
  }
`;
export const getPurchaseOrder = /* GraphQL */ `
  query GetPurchaseOrder($id: ID!) {
    getPurchaseOrder(id: $id) {
      id
      tenantId
      activeFlag
      purchaseOrderNumber
      quoteId
      supplierId
      recapCostlineId
      costlineName
      costlineName_fr
      projectId
      poAvailable
      supplierName
      supplierTerms
      quantity
      number
      rate
      provisionalTotal
      taxRate
      deliveryDate
      deliveryAddress
      comments
      _version
      _deleted
      _lastChangedAt
      createdOn
      updatedOn
    }
  }
`;
export const listPurchaseOrders = /* GraphQL */ `
  query ListPurchaseOrders(
    $filter: ModelPurchaseOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPurchaseOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        tenantId
        activeFlag
        purchaseOrderNumber
        quoteId
        supplierId
        recapCostlineId
        costlineName
        costlineName_fr
        projectId
        poAvailable
        supplierName
        supplierTerms
        quantity
        number
        rate
        provisionalTotal
        taxRate
        deliveryDate
        deliveryAddress
        comments
        _version
        _deleted
        _lastChangedAt
        createdOn
        updatedOn
      }
      nextToken
      startedAt
    }
  }
`;
export const syncClients = /* GraphQL */ `
  query SyncClients(
    $filter: ModelClientsFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncClients(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        email
        tenantId
        offlineIds
        activeFlag
        projects {
          items {
            id
            name
            tenantId
            freelancers
            childFreelancers
            offlineIds
            parentProjectId
            parentClientId
            activeFlag
            type
            projectType
            parentCompanyId
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getClients = /* GraphQL */ `
  query GetClients($id: ID!) {
    getClients(id: $id) {
      id
      name
      email
      tenantId
      offlineIds
      activeFlag
      projects {
        items {
          id
          name
          tenantId
          freelancers
          childFreelancers
          offlineIds
          parentProjectId
          parentClientId
          activeFlag
          type
          projectType
          parentCompanyId
          childProjects {
            nextToken
            startedAt
          }
          quotes {
            nextToken
            startedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdOn
      updatedOn
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listClientss = /* GraphQL */ `
  query ListClientss(
    $filter: ModelClientsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listClientss(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        email
        tenantId
        offlineIds
        activeFlag
        projects {
          items {
            id
            name
            tenantId
            freelancers
            childFreelancers
            offlineIds
            parentProjectId
            parentClientId
            activeFlag
            type
            projectType
            parentCompanyId
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncProjects = /* GraphQL */ `
  query SyncProjects(
    $filter: ModelProjectsFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncProjects(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        tenantId
        freelancers
        childFreelancers
        offlineIds
        parentProjectId
        parentClientId
        activeFlag
        type
        projectType
        parentCompanyId
        childProjects {
          items {
            id
            name
            tenantId
            freelancers
            childFreelancers
            offlineIds
            parentProjectId
            parentClientId
            activeFlag
            type
            projectType
            parentCompanyId
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
        quotes {
          items {
            id
            name
            tenantId
            quoteType
            childFreelancers
            offlineIds
            activeFlag
            type
            parentProjectId
            billLocation
            marginPercentage
            overheadPercentage
            exchangeRate
            allowInternational
            freelancers
            parentCompanyId
            maximizeMinimize
            clientName
            projectName
            agency
            agencyRepresentative
            director
            executiveProducer
            lineProducer
            numberOfShootingDays
            notes
            introduction
            shooting
            prep
            shootingCountry
            prelight
            casting
            crew
            buyouts
            locations
            studio
            artDepartment
            wardrobe
            equipment
            travel
            accommodation
            editing
            imagePostproduction
            soundPostproduction
            deliverables
            insurance
            quoteGuidelines
            excluded
            paymentTerms
            miscellaneous
            installment1Percentage
            installment1Date
            installment2Percentage
            installment2Date
            balancePercentage
            balanceDate
            isStarred
            isChecked
            recapInfoComments
            contact
            advertiserJobID
            brand
            jobName
            agencyJobID
            product
            advertiser
            productionJobID
            advertiserAddress
            productionCompany
            productionContact
            vfxCo
            vfxProducer
            editorialCo
            editorialProducer
            musicCo
            musicProducer
            agencyProducer
            agencyCreativeTeam
            prepDays
            buildAndStrikeDays
            preLight
            stageDays
            locationDays
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getProjects = /* GraphQL */ `
  query GetProjects($id: ID!) {
    getProjects(id: $id) {
      id
      name
      tenantId
      freelancers
      childFreelancers
      offlineIds
      parentProjectId
      parentClientId
      activeFlag
      type
      projectType
      parentCompanyId
      childProjects {
        items {
          id
          name
          tenantId
          freelancers
          childFreelancers
          offlineIds
          parentProjectId
          parentClientId
          activeFlag
          type
          projectType
          parentCompanyId
          childProjects {
            nextToken
            startedAt
          }
          quotes {
            nextToken
            startedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      quotes {
        items {
          id
          name
          tenantId
          quoteType
          childFreelancers
          offlineIds
          activeFlag
          type
          parentProjectId
          billLocation
          marginPercentage
          overheadPercentage
          exchangeRate
          allowInternational
          freelancers
          parentCompanyId
          maximizeMinimize
          clientName
          projectName
          agency
          agencyRepresentative
          director
          executiveProducer
          lineProducer
          numberOfShootingDays
          notes
          introduction
          shooting
          prep
          shootingCountry
          prelight
          casting
          crew
          buyouts
          locations
          studio
          artDepartment
          wardrobe
          equipment
          travel
          accommodation
          editing
          imagePostproduction
          soundPostproduction
          deliverables
          insurance
          quoteGuidelines
          excluded
          paymentTerms
          miscellaneous
          installment1Percentage
          installment1Date
          installment2Percentage
          installment2Date
          balancePercentage
          balanceDate
          isStarred
          isChecked
          recapInfoComments
          contact
          discount {
            totalDiscount
            totalAfterDiscount
            totalDiscountOnMargin
            totalDiscountOnMarginPercentage
            totalDiscountPercentage
          }
          advertiserJobID
          brand
          jobName
          agencyJobID
          product
          advertiser
          productionJobID
          advertiserAddress
          productionCompany
          productionContact
          vfxCo
          vfxProducer
          editorialCo
          editorialProducer
          musicCo
          musicProducer
          agencyProducer
          agencyCreativeTeam
          prepDays
          buildAndStrikeDays
          preLight
          stageDays
          locationDays
          recapInfo {
            nextToken
            startedAt
          }
          quoteInfo {
            nextToken
            startedAt
          }
          proposals {
            nextToken
            startedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdOn
      updatedOn
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listProjectss = /* GraphQL */ `
  query ListProjectss(
    $filter: ModelProjectsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjectss(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        tenantId
        freelancers
        childFreelancers
        offlineIds
        parentProjectId
        parentClientId
        activeFlag
        type
        projectType
        parentCompanyId
        childProjects {
          items {
            id
            name
            tenantId
            freelancers
            childFreelancers
            offlineIds
            parentProjectId
            parentClientId
            activeFlag
            type
            projectType
            parentCompanyId
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
        quotes {
          items {
            id
            name
            tenantId
            quoteType
            childFreelancers
            offlineIds
            activeFlag
            type
            parentProjectId
            billLocation
            marginPercentage
            overheadPercentage
            exchangeRate
            allowInternational
            freelancers
            parentCompanyId
            maximizeMinimize
            clientName
            projectName
            agency
            agencyRepresentative
            director
            executiveProducer
            lineProducer
            numberOfShootingDays
            notes
            introduction
            shooting
            prep
            shootingCountry
            prelight
            casting
            crew
            buyouts
            locations
            studio
            artDepartment
            wardrobe
            equipment
            travel
            accommodation
            editing
            imagePostproduction
            soundPostproduction
            deliverables
            insurance
            quoteGuidelines
            excluded
            paymentTerms
            miscellaneous
            installment1Percentage
            installment1Date
            installment2Percentage
            installment2Date
            balancePercentage
            balanceDate
            isStarred
            isChecked
            recapInfoComments
            contact
            advertiserJobID
            brand
            jobName
            agencyJobID
            product
            advertiser
            productionJobID
            advertiserAddress
            productionCompany
            productionContact
            vfxCo
            vfxProducer
            editorialCo
            editorialProducer
            musicCo
            musicProducer
            agencyProducer
            agencyCreativeTeam
            prepDays
            buildAndStrikeDays
            preLight
            stageDays
            locationDays
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncProposals = /* GraphQL */ `
  query SyncProposals(
    $filter: ModelProposalsFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncProposals(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        tenantId
        activeFlag
        quoteId
        clientId
        status
        noofInvoices
        quoteName
        projectName
        clientTaxType
        clientName
        contactName
        clientEmail
        clientAddress
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        paymentTerms
        total
        clientNote
        isDetailed
        bankProfileNumber
        proposalsBankProfileName
        proposalsBank
        proposalsIban
        proposalsBic
        proposalsAccountName
        drafts {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
        }
        quote {
          id
          name
          tenantId
          quoteType
          childFreelancers
          offlineIds
          activeFlag
          type
          parentProjectId
          billLocation
          marginPercentage
          overheadPercentage
          exchangeRate
          allowInternational
          freelancers
          parentCompanyId
          maximizeMinimize
          clientName
          projectName
          agency
          agencyRepresentative
          director
          executiveProducer
          lineProducer
          numberOfShootingDays
          notes
          introduction
          shooting
          prep
          shootingCountry
          prelight
          casting
          crew
          buyouts
          locations
          studio
          artDepartment
          wardrobe
          equipment
          travel
          accommodation
          editing
          imagePostproduction
          soundPostproduction
          deliverables
          insurance
          quoteGuidelines
          excluded
          paymentTerms
          miscellaneous
          installment1Percentage
          installment1Date
          installment2Percentage
          installment2Date
          balancePercentage
          balanceDate
          isStarred
          isChecked
          recapInfoComments
          contact
          discount {
            totalDiscount
            totalAfterDiscount
            totalDiscountOnMargin
            totalDiscountOnMarginPercentage
            totalDiscountPercentage
          }
          advertiserJobID
          brand
          jobName
          agencyJobID
          product
          advertiser
          productionJobID
          advertiserAddress
          productionCompany
          productionContact
          vfxCo
          vfxProducer
          editorialCo
          editorialProducer
          musicCo
          musicProducer
          agencyProducer
          agencyCreativeTeam
          prepDays
          buildAndStrikeDays
          preLight
          stageDays
          locationDays
          recapInfo {
            nextToken
            startedAt
          }
          quoteInfo {
            nextToken
            startedAt
          }
          proposals {
            nextToken
            startedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        invoices {
          items {
            id
            tenantId
            proposalId
            activeFlag
            originalInvoiceId
            creditInvoiceGenerated
            archivedDate
            paidDate
            paymentStatus
            quoteName
            projectName
            clientId
            clientName
            contactName
            clientTaxType
            clientEmail
            clientAddress
            clientIdNumber
            clientVatNumber
            clientCurrency
            clientTaxRate
            title
            invoiceNumber
            poNumber
            invoiceAmountPercentage
            amount
            amountAfterTax
            taxAmount
            balancePercentage
            balanceAmount
            clientNote
            isDetailed
            bankProfileNumber
            invoicesBankProfileName
            invoicesBank
            invoicesIban
            invoicesBic
            invoicesAccountName
            invoiceDate
            invoiceDueDate
            description
            creditComments
            invoiceType
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getProposals = /* GraphQL */ `
  query GetProposals($id: ID!) {
    getProposals(id: $id) {
      id
      tenantId
      activeFlag
      quoteId
      clientId
      status
      noofInvoices
      quoteName
      projectName
      clientTaxType
      clientName
      contactName
      clientEmail
      clientAddress
      clientIdNumber
      clientVatNumber
      clientCurrency
      clientTaxRate
      paymentTerms
      total
      clientNote
      isDetailed
      bankProfileNumber
      proposalsBankProfileName
      proposalsBank
      proposalsIban
      proposalsBic
      proposalsAccountName
      drafts {
        generated
        poNumber
        proposalAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        invoiceId
        invoiceDate
        invoiceDueDate
        description
        readyStatus
      }
      quote {
        id
        name
        tenantId
        quoteType
        childFreelancers
        offlineIds
        activeFlag
        type
        parentProjectId
        billLocation
        marginPercentage
        overheadPercentage
        exchangeRate
        allowInternational
        freelancers
        parentCompanyId
        maximizeMinimize
        clientName
        projectName
        agency
        agencyRepresentative
        director
        executiveProducer
        lineProducer
        numberOfShootingDays
        notes
        introduction
        shooting
        prep
        shootingCountry
        prelight
        casting
        crew
        buyouts
        locations
        studio
        artDepartment
        wardrobe
        equipment
        travel
        accommodation
        editing
        imagePostproduction
        soundPostproduction
        deliverables
        insurance
        quoteGuidelines
        excluded
        paymentTerms
        miscellaneous
        installment1Percentage
        installment1Date
        installment2Percentage
        installment2Date
        balancePercentage
        balanceDate
        isStarred
        isChecked
        recapInfoComments
        contact
        discount {
          totalDiscount
          totalAfterDiscount
          totalDiscountOnMargin
          totalDiscountOnMarginPercentage
          totalDiscountPercentage
        }
        advertiserJobID
        brand
        jobName
        agencyJobID
        product
        advertiser
        productionJobID
        advertiserAddress
        productionCompany
        productionContact
        vfxCo
        vfxProducer
        editorialCo
        editorialProducer
        musicCo
        musicProducer
        agencyProducer
        agencyCreativeTeam
        prepDays
        buildAndStrikeDays
        preLight
        stageDays
        locationDays
        recapInfo {
          items {
            id
            quoteId
            tenantId
            freelancers
            childFreelancers
            offlineIds
            activeFlag
            uuid
            categoryId
            category
            category_fr
            categoryPrefix
            subCategoryId
            subCategory
            subCategory_fr
            subCategoryPrefix
            subCategorySuffix
            tableRowIndex
            item
            item_fr
            isInternational
            editable
            costLineType
            costLineLabel
            language
            number
            rate
            exchangeEnabled
            exchangeRate
            rateInEuros
            quantity
            total
            totalMargin
            payrollTaxEnabled
            payrollTaxType
            isCustomCostLine
            referenceCostLineUuid
            provisionalTotal
            provisionalPayrollTaxEnabled
            provisionalPayrollTaxType
            actualTotal
            actualPayrollTaxEnabled
            actualPayrollTaxType
            purchaseTotal
            supplierStatus
            supplierId
            paymentStatus
            purchaseId
            comments
            invoiceId
            invoiceAvailable
            poAvailable
            purchaseOrderId
            _version
            _deleted
            _lastChangedAt
            createdAt
            updatedAt
          }
          nextToken
          startedAt
        }
        quoteInfo {
          items {
            id
            quoteId
            tenantId
            freelancers
            childFreelancers
            offlineIds
            activeFlag
            agentCommission
            agentCommissionPercentage
            allowMarginAndOverheadPercentageGlobalUpdate
            language
            category
            categoryId
            categoryPrefix
            category_fr
            costLineLabel
            costLineType
            editable
            exchangeEnabled
            exchangeRate
            tableRowIndex
            isInternational
            isVisible
            item
            item_fr
            margin
            marginPercentage
            number
            overhead
            overheadPercentage
            overtimeHours
            overtimeHoursCost
            payrollTaxEnabled
            payrollTaxType
            quantity
            rate
            rateInEuros
            subCategory
            subCategoryId
            subCategoryPrefix
            subCategorySuffix
            subCategory_fr
            total
            totalHeading
            totalMargin
            unit
            smg
            _version
            _deleted
            _lastChangedAt
            createdAt
            updatedAt
          }
          nextToken
          startedAt
        }
        proposals {
          items {
            id
            tenantId
            activeFlag
            quoteId
            clientId
            status
            noofInvoices
            quoteName
            projectName
            clientTaxType
            clientName
            contactName
            clientEmail
            clientAddress
            clientIdNumber
            clientVatNumber
            clientCurrency
            clientTaxRate
            paymentTerms
            total
            clientNote
            isDetailed
            bankProfileNumber
            proposalsBankProfileName
            proposalsBank
            proposalsIban
            proposalsBic
            proposalsAccountName
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      invoices {
        items {
          id
          tenantId
          proposalId
          activeFlag
          originalInvoiceId
          creditInvoiceGenerated
          archivedDate
          paidDate
          paymentStatus
          quoteName
          projectName
          clientId
          clientName
          contactName
          clientTaxType
          clientEmail
          clientAddress
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          title
          invoiceNumber
          poNumber
          invoiceAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          clientNote
          isDetailed
          bankProfileNumber
          invoicesBankProfileName
          invoicesBank
          invoicesIban
          invoicesBic
          invoicesAccountName
          invoiceDate
          invoiceDueDate
          description
          creditComments
          invoiceType
          proposalsDraft {
            generated
            poNumber
            proposalAmountPercentage
            amount
            amountAfterTax
            taxAmount
            balancePercentage
            balanceAmount
            invoiceId
            invoiceDate
            invoiceDueDate
            description
            readyStatus
          }
          proposals {
            id
            tenantId
            activeFlag
            quoteId
            clientId
            status
            noofInvoices
            quoteName
            projectName
            clientTaxType
            clientName
            contactName
            clientEmail
            clientAddress
            clientIdNumber
            clientVatNumber
            clientCurrency
            clientTaxRate
            paymentTerms
            total
            clientNote
            isDetailed
            bankProfileNumber
            proposalsBankProfileName
            proposalsBank
            proposalsIban
            proposalsBic
            proposalsAccountName
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdOn
      updatedOn
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listProposalss = /* GraphQL */ `
  query ListProposalss(
    $filter: ModelProposalsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProposalss(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        tenantId
        activeFlag
        quoteId
        clientId
        status
        noofInvoices
        quoteName
        projectName
        clientTaxType
        clientName
        contactName
        clientEmail
        clientAddress
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        paymentTerms
        total
        clientNote
        isDetailed
        bankProfileNumber
        proposalsBankProfileName
        proposalsBank
        proposalsIban
        proposalsBic
        proposalsAccountName
        drafts {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
        }
        quote {
          id
          name
          tenantId
          quoteType
          childFreelancers
          offlineIds
          activeFlag
          type
          parentProjectId
          billLocation
          marginPercentage
          overheadPercentage
          exchangeRate
          allowInternational
          freelancers
          parentCompanyId
          maximizeMinimize
          clientName
          projectName
          agency
          agencyRepresentative
          director
          executiveProducer
          lineProducer
          numberOfShootingDays
          notes
          introduction
          shooting
          prep
          shootingCountry
          prelight
          casting
          crew
          buyouts
          locations
          studio
          artDepartment
          wardrobe
          equipment
          travel
          accommodation
          editing
          imagePostproduction
          soundPostproduction
          deliverables
          insurance
          quoteGuidelines
          excluded
          paymentTerms
          miscellaneous
          installment1Percentage
          installment1Date
          installment2Percentage
          installment2Date
          balancePercentage
          balanceDate
          isStarred
          isChecked
          recapInfoComments
          contact
          discount {
            totalDiscount
            totalAfterDiscount
            totalDiscountOnMargin
            totalDiscountOnMarginPercentage
            totalDiscountPercentage
          }
          advertiserJobID
          brand
          jobName
          agencyJobID
          product
          advertiser
          productionJobID
          advertiserAddress
          productionCompany
          productionContact
          vfxCo
          vfxProducer
          editorialCo
          editorialProducer
          musicCo
          musicProducer
          agencyProducer
          agencyCreativeTeam
          prepDays
          buildAndStrikeDays
          preLight
          stageDays
          locationDays
          recapInfo {
            nextToken
            startedAt
          }
          quoteInfo {
            nextToken
            startedAt
          }
          proposals {
            nextToken
            startedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        invoices {
          items {
            id
            tenantId
            proposalId
            activeFlag
            originalInvoiceId
            creditInvoiceGenerated
            archivedDate
            paidDate
            paymentStatus
            quoteName
            projectName
            clientId
            clientName
            contactName
            clientTaxType
            clientEmail
            clientAddress
            clientIdNumber
            clientVatNumber
            clientCurrency
            clientTaxRate
            title
            invoiceNumber
            poNumber
            invoiceAmountPercentage
            amount
            amountAfterTax
            taxAmount
            balancePercentage
            balanceAmount
            clientNote
            isDetailed
            bankProfileNumber
            invoicesBankProfileName
            invoicesBank
            invoicesIban
            invoicesBic
            invoicesAccountName
            invoiceDate
            invoiceDueDate
            description
            creditComments
            invoiceType
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncInvoices = /* GraphQL */ `
  query SyncInvoices(
    $filter: ModelInvoicesFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncInvoices(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        tenantId
        proposalId
        activeFlag
        originalInvoiceId
        creditInvoiceGenerated
        archivedDate
        paidDate
        paymentStatus
        quoteName
        projectName
        clientId
        clientName
        contactName
        clientTaxType
        clientEmail
        clientAddress
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        title
        invoiceNumber
        poNumber
        invoiceAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        clientNote
        isDetailed
        bankProfileNumber
        invoicesBankProfileName
        invoicesBank
        invoicesIban
        invoicesBic
        invoicesAccountName
        invoiceDate
        invoiceDueDate
        description
        creditComments
        invoiceType
        proposalsDraft {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
        }
        proposals {
          id
          tenantId
          activeFlag
          quoteId
          clientId
          status
          noofInvoices
          quoteName
          projectName
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          drafts {
            generated
            poNumber
            proposalAmountPercentage
            amount
            amountAfterTax
            taxAmount
            balancePercentage
            balanceAmount
            invoiceId
            invoiceDate
            invoiceDueDate
            description
            readyStatus
          }
          quote {
            id
            name
            tenantId
            quoteType
            childFreelancers
            offlineIds
            activeFlag
            type
            parentProjectId
            billLocation
            marginPercentage
            overheadPercentage
            exchangeRate
            allowInternational
            freelancers
            parentCompanyId
            maximizeMinimize
            clientName
            projectName
            agency
            agencyRepresentative
            director
            executiveProducer
            lineProducer
            numberOfShootingDays
            notes
            introduction
            shooting
            prep
            shootingCountry
            prelight
            casting
            crew
            buyouts
            locations
            studio
            artDepartment
            wardrobe
            equipment
            travel
            accommodation
            editing
            imagePostproduction
            soundPostproduction
            deliverables
            insurance
            quoteGuidelines
            excluded
            paymentTerms
            miscellaneous
            installment1Percentage
            installment1Date
            installment2Percentage
            installment2Date
            balancePercentage
            balanceDate
            isStarred
            isChecked
            recapInfoComments
            contact
            advertiserJobID
            brand
            jobName
            agencyJobID
            product
            advertiser
            productionJobID
            advertiserAddress
            productionCompany
            productionContact
            vfxCo
            vfxProducer
            editorialCo
            editorialProducer
            musicCo
            musicProducer
            agencyProducer
            agencyCreativeTeam
            prepDays
            buildAndStrikeDays
            preLight
            stageDays
            locationDays
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          invoices {
            nextToken
            startedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getInvoices = /* GraphQL */ `
  query GetInvoices($id: ID!) {
    getInvoices(id: $id) {
      id
      tenantId
      proposalId
      activeFlag
      originalInvoiceId
      creditInvoiceGenerated
      archivedDate
      paidDate
      paymentStatus
      quoteName
      projectName
      clientId
      clientName
      contactName
      clientTaxType
      clientEmail
      clientAddress
      clientIdNumber
      clientVatNumber
      clientCurrency
      clientTaxRate
      title
      invoiceNumber
      poNumber
      invoiceAmountPercentage
      amount
      amountAfterTax
      taxAmount
      balancePercentage
      balanceAmount
      clientNote
      isDetailed
      bankProfileNumber
      invoicesBankProfileName
      invoicesBank
      invoicesIban
      invoicesBic
      invoicesAccountName
      invoiceDate
      invoiceDueDate
      description
      creditComments
      invoiceType
      proposalsDraft {
        generated
        poNumber
        proposalAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        invoiceId
        invoiceDate
        invoiceDueDate
        description
        readyStatus
      }
      proposals {
        id
        tenantId
        activeFlag
        quoteId
        clientId
        status
        noofInvoices
        quoteName
        projectName
        clientTaxType
        clientName
        contactName
        clientEmail
        clientAddress
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        paymentTerms
        total
        clientNote
        isDetailed
        bankProfileNumber
        proposalsBankProfileName
        proposalsBank
        proposalsIban
        proposalsBic
        proposalsAccountName
        drafts {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
        }
        quote {
          id
          name
          tenantId
          quoteType
          childFreelancers
          offlineIds
          activeFlag
          type
          parentProjectId
          billLocation
          marginPercentage
          overheadPercentage
          exchangeRate
          allowInternational
          freelancers
          parentCompanyId
          maximizeMinimize
          clientName
          projectName
          agency
          agencyRepresentative
          director
          executiveProducer
          lineProducer
          numberOfShootingDays
          notes
          introduction
          shooting
          prep
          shootingCountry
          prelight
          casting
          crew
          buyouts
          locations
          studio
          artDepartment
          wardrobe
          equipment
          travel
          accommodation
          editing
          imagePostproduction
          soundPostproduction
          deliverables
          insurance
          quoteGuidelines
          excluded
          paymentTerms
          miscellaneous
          installment1Percentage
          installment1Date
          installment2Percentage
          installment2Date
          balancePercentage
          balanceDate
          isStarred
          isChecked
          recapInfoComments
          contact
          discount {
            totalDiscount
            totalAfterDiscount
            totalDiscountOnMargin
            totalDiscountOnMarginPercentage
            totalDiscountPercentage
          }
          advertiserJobID
          brand
          jobName
          agencyJobID
          product
          advertiser
          productionJobID
          advertiserAddress
          productionCompany
          productionContact
          vfxCo
          vfxProducer
          editorialCo
          editorialProducer
          musicCo
          musicProducer
          agencyProducer
          agencyCreativeTeam
          prepDays
          buildAndStrikeDays
          preLight
          stageDays
          locationDays
          recapInfo {
            nextToken
            startedAt
          }
          quoteInfo {
            nextToken
            startedAt
          }
          proposals {
            nextToken
            startedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        invoices {
          items {
            id
            tenantId
            proposalId
            activeFlag
            originalInvoiceId
            creditInvoiceGenerated
            archivedDate
            paidDate
            paymentStatus
            quoteName
            projectName
            clientId
            clientName
            contactName
            clientTaxType
            clientEmail
            clientAddress
            clientIdNumber
            clientVatNumber
            clientCurrency
            clientTaxRate
            title
            invoiceNumber
            poNumber
            invoiceAmountPercentage
            amount
            amountAfterTax
            taxAmount
            balancePercentage
            balanceAmount
            clientNote
            isDetailed
            bankProfileNumber
            invoicesBankProfileName
            invoicesBank
            invoicesIban
            invoicesBic
            invoicesAccountName
            invoiceDate
            invoiceDueDate
            description
            creditComments
            invoiceType
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      createdOn
      updatedOn
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listInvoicess = /* GraphQL */ `
  query ListInvoicess(
    $filter: ModelInvoicesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInvoicess(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        tenantId
        proposalId
        activeFlag
        originalInvoiceId
        creditInvoiceGenerated
        archivedDate
        paidDate
        paymentStatus
        quoteName
        projectName
        clientId
        clientName
        contactName
        clientTaxType
        clientEmail
        clientAddress
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        title
        invoiceNumber
        poNumber
        invoiceAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        clientNote
        isDetailed
        bankProfileNumber
        invoicesBankProfileName
        invoicesBank
        invoicesIban
        invoicesBic
        invoicesAccountName
        invoiceDate
        invoiceDueDate
        description
        creditComments
        invoiceType
        proposalsDraft {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
        }
        proposals {
          id
          tenantId
          activeFlag
          quoteId
          clientId
          status
          noofInvoices
          quoteName
          projectName
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          drafts {
            generated
            poNumber
            proposalAmountPercentage
            amount
            amountAfterTax
            taxAmount
            balancePercentage
            balanceAmount
            invoiceId
            invoiceDate
            invoiceDueDate
            description
            readyStatus
          }
          quote {
            id
            name
            tenantId
            quoteType
            childFreelancers
            offlineIds
            activeFlag
            type
            parentProjectId
            billLocation
            marginPercentage
            overheadPercentage
            exchangeRate
            allowInternational
            freelancers
            parentCompanyId
            maximizeMinimize
            clientName
            projectName
            agency
            agencyRepresentative
            director
            executiveProducer
            lineProducer
            numberOfShootingDays
            notes
            introduction
            shooting
            prep
            shootingCountry
            prelight
            casting
            crew
            buyouts
            locations
            studio
            artDepartment
            wardrobe
            equipment
            travel
            accommodation
            editing
            imagePostproduction
            soundPostproduction
            deliverables
            insurance
            quoteGuidelines
            excluded
            paymentTerms
            miscellaneous
            installment1Percentage
            installment1Date
            installment2Percentage
            installment2Date
            balancePercentage
            balanceDate
            isStarred
            isChecked
            recapInfoComments
            contact
            advertiserJobID
            brand
            jobName
            agencyJobID
            product
            advertiser
            productionJobID
            advertiserAddress
            productionCompany
            productionContact
            vfxCo
            vfxProducer
            editorialCo
            editorialProducer
            musicCo
            musicProducer
            agencyProducer
            agencyCreativeTeam
            prepDays
            buildAndStrikeDays
            preLight
            stageDays
            locationDays
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          invoices {
            nextToken
            startedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncQuotes = /* GraphQL */ `
  query SyncQuotes(
    $filter: ModelQuoteFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncQuotes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        tenantId
        quoteType
        childFreelancers
        offlineIds
        activeFlag
        type
        parentProjectId
        billLocation
        marginPercentage
        overheadPercentage
        exchangeRate
        allowInternational
        freelancers
        parentCompanyId
        maximizeMinimize
        clientName
        projectName
        agency
        agencyRepresentative
        director
        executiveProducer
        lineProducer
        numberOfShootingDays
        notes
        introduction
        shooting
        prep
        shootingCountry
        prelight
        casting
        crew
        buyouts
        locations
        studio
        artDepartment
        wardrobe
        equipment
        travel
        accommodation
        editing
        imagePostproduction
        soundPostproduction
        deliverables
        insurance
        quoteGuidelines
        excluded
        paymentTerms
        miscellaneous
        installment1Percentage
        installment1Date
        installment2Percentage
        installment2Date
        balancePercentage
        balanceDate
        isStarred
        isChecked
        recapInfoComments
        contact
        discount {
          totalDiscount
          totalAfterDiscount
          totalDiscountOnMargin
          totalDiscountOnMarginPercentage
          totalDiscountPercentage
        }
        advertiserJobID
        brand
        jobName
        agencyJobID
        product
        advertiser
        productionJobID
        advertiserAddress
        productionCompany
        productionContact
        vfxCo
        vfxProducer
        editorialCo
        editorialProducer
        musicCo
        musicProducer
        agencyProducer
        agencyCreativeTeam
        prepDays
        buildAndStrikeDays
        preLight
        stageDays
        locationDays
        recapInfo {
          items {
            id
            quoteId
            tenantId
            freelancers
            childFreelancers
            offlineIds
            activeFlag
            uuid
            categoryId
            category
            category_fr
            categoryPrefix
            subCategoryId
            subCategory
            subCategory_fr
            subCategoryPrefix
            subCategorySuffix
            tableRowIndex
            item
            item_fr
            isInternational
            editable
            costLineType
            costLineLabel
            language
            number
            rate
            exchangeEnabled
            exchangeRate
            rateInEuros
            quantity
            total
            totalMargin
            payrollTaxEnabled
            payrollTaxType
            isCustomCostLine
            referenceCostLineUuid
            provisionalTotal
            provisionalPayrollTaxEnabled
            provisionalPayrollTaxType
            actualTotal
            actualPayrollTaxEnabled
            actualPayrollTaxType
            purchaseTotal
            supplierStatus
            supplierId
            paymentStatus
            purchaseId
            comments
            invoiceId
            invoiceAvailable
            poAvailable
            purchaseOrderId
            _version
            _deleted
            _lastChangedAt
            createdAt
            updatedAt
          }
          nextToken
          startedAt
        }
        quoteInfo {
          items {
            id
            quoteId
            tenantId
            freelancers
            childFreelancers
            offlineIds
            activeFlag
            agentCommission
            agentCommissionPercentage
            allowMarginAndOverheadPercentageGlobalUpdate
            language
            category
            categoryId
            categoryPrefix
            category_fr
            costLineLabel
            costLineType
            editable
            exchangeEnabled
            exchangeRate
            tableRowIndex
            isInternational
            isVisible
            item
            item_fr
            margin
            marginPercentage
            number
            overhead
            overheadPercentage
            overtimeHours
            overtimeHoursCost
            payrollTaxEnabled
            payrollTaxType
            quantity
            rate
            rateInEuros
            subCategory
            subCategoryId
            subCategoryPrefix
            subCategorySuffix
            subCategory_fr
            total
            totalHeading
            totalMargin
            unit
            smg
            _version
            _deleted
            _lastChangedAt
            createdAt
            updatedAt
          }
          nextToken
          startedAt
        }
        proposals {
          items {
            id
            tenantId
            activeFlag
            quoteId
            clientId
            status
            noofInvoices
            quoteName
            projectName
            clientTaxType
            clientName
            contactName
            clientEmail
            clientAddress
            clientIdNumber
            clientVatNumber
            clientCurrency
            clientTaxRate
            paymentTerms
            total
            clientNote
            isDetailed
            bankProfileNumber
            proposalsBankProfileName
            proposalsBank
            proposalsIban
            proposalsBic
            proposalsAccountName
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getQuote = /* GraphQL */ `
  query GetQuote($id: ID!) {
    getQuote(id: $id) {
      id
      name
      tenantId
      quoteType
      childFreelancers
      offlineIds
      activeFlag
      type
      parentProjectId
      billLocation
      marginPercentage
      overheadPercentage
      exchangeRate
      allowInternational
      freelancers
      parentCompanyId
      maximizeMinimize
      clientName
      projectName
      agency
      agencyRepresentative
      director
      executiveProducer
      lineProducer
      numberOfShootingDays
      notes
      introduction
      shooting
      prep
      shootingCountry
      prelight
      casting
      crew
      buyouts
      locations
      studio
      artDepartment
      wardrobe
      equipment
      travel
      accommodation
      editing
      imagePostproduction
      soundPostproduction
      deliverables
      insurance
      quoteGuidelines
      excluded
      paymentTerms
      miscellaneous
      installment1Percentage
      installment1Date
      installment2Percentage
      installment2Date
      balancePercentage
      balanceDate
      isStarred
      isChecked
      recapInfoComments
      contact
      discount {
        totalDiscount
        totalAfterDiscount
        totalDiscountOnMargin
        totalDiscountOnMarginPercentage
        totalDiscountPercentage
      }
      advertiserJobID
      brand
      jobName
      agencyJobID
      product
      advertiser
      productionJobID
      advertiserAddress
      productionCompany
      productionContact
      vfxCo
      vfxProducer
      editorialCo
      editorialProducer
      musicCo
      musicProducer
      agencyProducer
      agencyCreativeTeam
      prepDays
      buildAndStrikeDays
      preLight
      stageDays
      locationDays
      recapInfo {
        items {
          id
          quoteId
          tenantId
          freelancers
          childFreelancers
          offlineIds
          activeFlag
          uuid
          categoryId
          category
          category_fr
          categoryPrefix
          subCategoryId
          subCategory
          subCategory_fr
          subCategoryPrefix
          subCategorySuffix
          tableRowIndex
          item
          item_fr
          isInternational
          editable
          costLineType
          costLineLabel
          language
          number
          rate
          exchangeEnabled
          exchangeRate
          rateInEuros
          quantity
          total
          totalMargin
          payrollTaxEnabled
          payrollTaxType
          isCustomCostLine
          referenceCostLineUuid
          provisionalTotal
          provisionalPayrollTaxEnabled
          provisionalPayrollTaxType
          actualTotal
          actualPayrollTaxEnabled
          actualPayrollTaxType
          purchaseTotal
          supplierStatus
          supplierId
          paymentStatus
          purchaseId
          comments
          invoiceId
          invoiceAvailable
          invoiceDocuments {
            bucket
            region
            key
            identityId
          }
          poAvailable
          purchaseOrderId
          _version
          _deleted
          _lastChangedAt
          createdAt
          updatedAt
        }
        nextToken
        startedAt
      }
      quoteInfo {
        items {
          id
          quoteId
          tenantId
          freelancers
          childFreelancers
          offlineIds
          activeFlag
          agentCommission
          agentCommissionPercentage
          allowMarginAndOverheadPercentageGlobalUpdate
          language
          category
          categoryId
          categoryPrefix
          category_fr
          costLineLabel
          costLineType
          editable
          exchangeEnabled
          exchangeRate
          tableRowIndex
          isInternational
          isVisible
          item
          item_fr
          margin
          marginPercentage
          number
          overhead
          overheadPercentage
          overtimeDetails {
            multiplier
            overtimeHours
          }
          overtimeHours
          overtimeHoursCost
          payrollTaxEnabled
          payrollTaxType
          quantity
          rate
          rateInEuros
          subCategory
          subCategoryId
          subCategoryPrefix
          subCategorySuffix
          subCategory_fr
          total
          totalHeading
          totalMargin
          unit
          smg
          _version
          _deleted
          _lastChangedAt
          createdAt
          updatedAt
        }
        nextToken
        startedAt
      }
      proposals {
        items {
          id
          tenantId
          activeFlag
          quoteId
          clientId
          status
          noofInvoices
          quoteName
          projectName
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          drafts {
            generated
            poNumber
            proposalAmountPercentage
            amount
            amountAfterTax
            taxAmount
            balancePercentage
            balanceAmount
            invoiceId
            invoiceDate
            invoiceDueDate
            description
            readyStatus
          }
          quote {
            id
            name
            tenantId
            quoteType
            childFreelancers
            offlineIds
            activeFlag
            type
            parentProjectId
            billLocation
            marginPercentage
            overheadPercentage
            exchangeRate
            allowInternational
            freelancers
            parentCompanyId
            maximizeMinimize
            clientName
            projectName
            agency
            agencyRepresentative
            director
            executiveProducer
            lineProducer
            numberOfShootingDays
            notes
            introduction
            shooting
            prep
            shootingCountry
            prelight
            casting
            crew
            buyouts
            locations
            studio
            artDepartment
            wardrobe
            equipment
            travel
            accommodation
            editing
            imagePostproduction
            soundPostproduction
            deliverables
            insurance
            quoteGuidelines
            excluded
            paymentTerms
            miscellaneous
            installment1Percentage
            installment1Date
            installment2Percentage
            installment2Date
            balancePercentage
            balanceDate
            isStarred
            isChecked
            recapInfoComments
            contact
            advertiserJobID
            brand
            jobName
            agencyJobID
            product
            advertiser
            productionJobID
            advertiserAddress
            productionCompany
            productionContact
            vfxCo
            vfxProducer
            editorialCo
            editorialProducer
            musicCo
            musicProducer
            agencyProducer
            agencyCreativeTeam
            prepDays
            buildAndStrikeDays
            preLight
            stageDays
            locationDays
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          invoices {
            nextToken
            startedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdOn
      updatedOn
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listQuotes = /* GraphQL */ `
  query ListQuotes(
    $filter: ModelQuoteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQuotes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        tenantId
        quoteType
        childFreelancers
        offlineIds
        activeFlag
        type
        parentProjectId
        billLocation
        marginPercentage
        overheadPercentage
        exchangeRate
        allowInternational
        freelancers
        parentCompanyId
        maximizeMinimize
        clientName
        projectName
        agency
        agencyRepresentative
        director
        executiveProducer
        lineProducer
        numberOfShootingDays
        notes
        introduction
        shooting
        prep
        shootingCountry
        prelight
        casting
        crew
        buyouts
        locations
        studio
        artDepartment
        wardrobe
        equipment
        travel
        accommodation
        editing
        imagePostproduction
        soundPostproduction
        deliverables
        insurance
        quoteGuidelines
        excluded
        paymentTerms
        miscellaneous
        installment1Percentage
        installment1Date
        installment2Percentage
        installment2Date
        balancePercentage
        balanceDate
        isStarred
        isChecked
        recapInfoComments
        contact
        discount {
          totalDiscount
          totalAfterDiscount
          totalDiscountOnMargin
          totalDiscountOnMarginPercentage
          totalDiscountPercentage
        }
        advertiserJobID
        brand
        jobName
        agencyJobID
        product
        advertiser
        productionJobID
        advertiserAddress
        productionCompany
        productionContact
        vfxCo
        vfxProducer
        editorialCo
        editorialProducer
        musicCo
        musicProducer
        agencyProducer
        agencyCreativeTeam
        prepDays
        buildAndStrikeDays
        preLight
        stageDays
        locationDays
        recapInfo {
          items {
            id
            quoteId
            tenantId
            freelancers
            childFreelancers
            offlineIds
            activeFlag
            uuid
            categoryId
            category
            category_fr
            categoryPrefix
            subCategoryId
            subCategory
            subCategory_fr
            subCategoryPrefix
            subCategorySuffix
            tableRowIndex
            item
            item_fr
            isInternational
            editable
            costLineType
            costLineLabel
            language
            number
            rate
            exchangeEnabled
            exchangeRate
            rateInEuros
            quantity
            total
            totalMargin
            payrollTaxEnabled
            payrollTaxType
            isCustomCostLine
            referenceCostLineUuid
            provisionalTotal
            provisionalPayrollTaxEnabled
            provisionalPayrollTaxType
            actualTotal
            actualPayrollTaxEnabled
            actualPayrollTaxType
            purchaseTotal
            supplierStatus
            supplierId
            paymentStatus
            purchaseId
            comments
            invoiceId
            invoiceAvailable
            poAvailable
            purchaseOrderId
            _version
            _deleted
            _lastChangedAt
            createdAt
            updatedAt
          }
          nextToken
          startedAt
        }
        quoteInfo {
          items {
            id
            quoteId
            tenantId
            freelancers
            childFreelancers
            offlineIds
            activeFlag
            agentCommission
            agentCommissionPercentage
            allowMarginAndOverheadPercentageGlobalUpdate
            language
            category
            categoryId
            categoryPrefix
            category_fr
            costLineLabel
            costLineType
            editable
            exchangeEnabled
            exchangeRate
            tableRowIndex
            isInternational
            isVisible
            item
            item_fr
            margin
            marginPercentage
            number
            overhead
            overheadPercentage
            overtimeHours
            overtimeHoursCost
            payrollTaxEnabled
            payrollTaxType
            quantity
            rate
            rateInEuros
            subCategory
            subCategoryId
            subCategoryPrefix
            subCategorySuffix
            subCategory_fr
            total
            totalHeading
            totalMargin
            unit
            smg
            _version
            _deleted
            _lastChangedAt
            createdAt
            updatedAt
          }
          nextToken
          startedAt
        }
        proposals {
          items {
            id
            tenantId
            activeFlag
            quoteId
            clientId
            status
            noofInvoices
            quoteName
            projectName
            clientTaxType
            clientName
            contactName
            clientEmail
            clientAddress
            clientIdNumber
            clientVatNumber
            clientCurrency
            clientTaxRate
            paymentTerms
            total
            clientNote
            isDetailed
            bankProfileNumber
            proposalsBankProfileName
            proposalsBank
            proposalsIban
            proposalsBic
            proposalsAccountName
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncQuoteInfos = /* GraphQL */ `
  query SyncQuoteInfos(
    $filter: ModelQuoteInfoFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncQuoteInfos(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        quoteId
        tenantId
        freelancers
        childFreelancers
        offlineIds
        activeFlag
        agentCommission
        agentCommissionPercentage
        allowMarginAndOverheadPercentageGlobalUpdate
        language
        category
        categoryId
        categoryPrefix
        category_fr
        costLineLabel
        costLineType
        editable
        exchangeEnabled
        exchangeRate
        tableRowIndex
        isInternational
        isVisible
        item
        item_fr
        margin
        marginPercentage
        number
        overhead
        overheadPercentage
        overtimeDetails {
          multiplier
          overtimeHours
        }
        overtimeHours
        overtimeHoursCost
        payrollTaxEnabled
        payrollTaxType
        quantity
        rate
        rateInEuros
        subCategory
        subCategoryId
        subCategoryPrefix
        subCategorySuffix
        subCategory_fr
        total
        totalHeading
        totalMargin
        unit
        smg
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getQuoteInfo = /* GraphQL */ `
  query GetQuoteInfo($id: ID!) {
    getQuoteInfo(id: $id) {
      id
      quoteId
      tenantId
      freelancers
      childFreelancers
      offlineIds
      activeFlag
      agentCommission
      agentCommissionPercentage
      allowMarginAndOverheadPercentageGlobalUpdate
      language
      category
      categoryId
      categoryPrefix
      category_fr
      costLineLabel
      costLineType
      editable
      exchangeEnabled
      exchangeRate
      tableRowIndex
      isInternational
      isVisible
      item
      item_fr
      margin
      marginPercentage
      number
      overhead
      overheadPercentage
      overtimeDetails {
        multiplier
        overtimeHours
      }
      overtimeHours
      overtimeHoursCost
      payrollTaxEnabled
      payrollTaxType
      quantity
      rate
      rateInEuros
      subCategory
      subCategoryId
      subCategoryPrefix
      subCategorySuffix
      subCategory_fr
      total
      totalHeading
      totalMargin
      unit
      smg
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const listQuoteInfos = /* GraphQL */ `
  query ListQuoteInfos(
    $filter: ModelQuoteInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQuoteInfos(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        quoteId
        tenantId
        freelancers
        childFreelancers
        offlineIds
        activeFlag
        agentCommission
        agentCommissionPercentage
        allowMarginAndOverheadPercentageGlobalUpdate
        language
        category
        categoryId
        categoryPrefix
        category_fr
        costLineLabel
        costLineType
        editable
        exchangeEnabled
        exchangeRate
        tableRowIndex
        isInternational
        isVisible
        item
        item_fr
        margin
        marginPercentage
        number
        overhead
        overheadPercentage
        overtimeDetails {
          multiplier
          overtimeHours
        }
        overtimeHours
        overtimeHoursCost
        payrollTaxEnabled
        payrollTaxType
        quantity
        rate
        rateInEuros
        subCategory
        subCategoryId
        subCategoryPrefix
        subCategorySuffix
        subCategory_fr
        total
        totalHeading
        totalMargin
        unit
        smg
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncRecapInfos = /* GraphQL */ `
  query SyncRecapInfos(
    $filter: ModelRecapInfoFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncRecapInfos(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        quoteId
        tenantId
        freelancers
        childFreelancers
        offlineIds
        activeFlag
        uuid
        categoryId
        category
        category_fr
        categoryPrefix
        subCategoryId
        subCategory
        subCategory_fr
        subCategoryPrefix
        subCategorySuffix
        tableRowIndex
        item
        item_fr
        isInternational
        editable
        costLineType
        costLineLabel
        language
        number
        rate
        exchangeEnabled
        exchangeRate
        rateInEuros
        quantity
        total
        totalMargin
        payrollTaxEnabled
        payrollTaxType
        isCustomCostLine
        referenceCostLineUuid
        provisionalTotal
        provisionalPayrollTaxEnabled
        provisionalPayrollTaxType
        actualTotal
        actualPayrollTaxEnabled
        actualPayrollTaxType
        purchaseTotal
        supplierStatus
        supplierId
        paymentStatus
        purchaseId
        comments
        invoiceId
        invoiceAvailable
        invoiceDocuments {
          bucket
          region
          key
          identityId
        }
        poAvailable
        purchaseOrderId
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getRecapInfo = /* GraphQL */ `
  query GetRecapInfo($id: ID!) {
    getRecapInfo(id: $id) {
      id
      quoteId
      tenantId
      freelancers
      childFreelancers
      offlineIds
      activeFlag
      uuid
      categoryId
      category
      category_fr
      categoryPrefix
      subCategoryId
      subCategory
      subCategory_fr
      subCategoryPrefix
      subCategorySuffix
      tableRowIndex
      item
      item_fr
      isInternational
      editable
      costLineType
      costLineLabel
      language
      number
      rate
      exchangeEnabled
      exchangeRate
      rateInEuros
      quantity
      total
      totalMargin
      payrollTaxEnabled
      payrollTaxType
      isCustomCostLine
      referenceCostLineUuid
      provisionalTotal
      provisionalPayrollTaxEnabled
      provisionalPayrollTaxType
      actualTotal
      actualPayrollTaxEnabled
      actualPayrollTaxType
      purchaseTotal
      supplierStatus
      supplierId
      paymentStatus
      purchaseId
      comments
      invoiceId
      invoiceAvailable
      invoiceDocuments {
        bucket
        region
        key
        identityId
      }
      poAvailable
      purchaseOrderId
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const listRecapInfos = /* GraphQL */ `
  query ListRecapInfos(
    $filter: ModelRecapInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRecapInfos(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        quoteId
        tenantId
        freelancers
        childFreelancers
        offlineIds
        activeFlag
        uuid
        categoryId
        category
        category_fr
        categoryPrefix
        subCategoryId
        subCategory
        subCategory_fr
        subCategoryPrefix
        subCategorySuffix
        tableRowIndex
        item
        item_fr
        isInternational
        editable
        costLineType
        costLineLabel
        language
        number
        rate
        exchangeEnabled
        exchangeRate
        rateInEuros
        quantity
        total
        totalMargin
        payrollTaxEnabled
        payrollTaxType
        isCustomCostLine
        referenceCostLineUuid
        provisionalTotal
        provisionalPayrollTaxEnabled
        provisionalPayrollTaxType
        actualTotal
        actualPayrollTaxEnabled
        actualPayrollTaxType
        purchaseTotal
        supplierStatus
        supplierId
        paymentStatus
        purchaseId
        comments
        invoiceId
        invoiceAvailable
        invoiceDocuments {
          bucket
          region
          key
          identityId
        }
        poAvailable
        purchaseOrderId
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const companyByEmailId = /* GraphQL */ `
  query CompanyByEmailId(
    $companyEmailId: String
    $sortDirection: ModelSortDirection
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    companyByEmailId(
      companyEmailId: $companyEmailId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenantId
        name
        email
        phone
        website
        registrationNumber
        vatNumber
        addressLine1
        addressLine2
        logoImage {
          bucket
          region
          key
          identityId
        }
        invoiceCount
        purchaseOrderInvoiceCount
        invoicingYear
        bank
        iban
        bic
        accountName
        bankProfileName
        bankProfileName2
        bank2
        iban2
        bic2
        accountName2
        bankProfileName3
        bank3
        iban3
        bic3
        accountName3
        duplicateQuoteCounter
        companyEmailId
        companyInvoices {
          bucket
          region
          key
          identityId
          fileName
          fileType
          fromEmailId
          thumbnailBucket
          thumbnailRegion
          thumbnailKey
          thumbnailIdentityId
        }
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const freelancersByEmail = /* GraphQL */ `
  query FreelancersByEmail(
    $email: String
    $sortDirection: ModelSortDirection
    $filter: ModelFreelancersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    freelancersByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        name
        freelancerTenantId
        companyTenantId
        profileImage {
          bucket
          region
          key
          identityId
        }
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const freelancersById = /* GraphQL */ `
  query FreelancersById(
    $freelancerTenantId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelFreelancersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    freelancersById(
      freelancerTenantId: $freelancerTenantId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        name
        freelancerTenantId
        companyTenantId
        profileImage {
          bucket
          region
          key
          identityId
        }
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const contactsByTenantId = /* GraphQL */ `
  query ContactsByTenantId(
    $tenantId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelContactFilterInput
    $limit: Int
    $nextToken: String
  ) {
    contactsByTenantId(
      tenantId: $tenantId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenantId
        activeFlag
        name
        idnumber
        vatNumber
        website
        phone
        firstName
        lastName
        email
        contactPhone
        line01
        line02
        city
        state
        postalCode
        country
        currency
        paymentTerms
        taxType
        taxRate
        note
        bank
        iban
        bic
        accountName
        invoices {
          items {
            id
            tenantId
            proposalId
            activeFlag
            originalInvoiceId
            creditInvoiceGenerated
            archivedDate
            paidDate
            paymentStatus
            quoteName
            projectName
            clientId
            clientName
            contactName
            clientTaxType
            clientEmail
            clientAddress
            clientIdNumber
            clientVatNumber
            clientCurrency
            clientTaxRate
            title
            invoiceNumber
            poNumber
            invoiceAmountPercentage
            amount
            amountAfterTax
            taxAmount
            balancePercentage
            balanceAmount
            clientNote
            isDetailed
            bankProfileNumber
            invoicesBankProfileName
            invoicesBank
            invoicesIban
            invoicesBic
            invoicesAccountName
            invoiceDate
            invoiceDueDate
            description
            creditComments
            invoiceType
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
        _version
        _deleted
        _lastChangedAt
        createdOn
        updatedOn
      }
      nextToken
      startedAt
    }
  }
`;
export const suppliersByTenantId = /* GraphQL */ `
  query SuppliersByTenantId(
    $tenantId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelSuppliersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    suppliersByTenantId(
      tenantId: $tenantId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenantId
        activeFlag
        name
        idnumber
        vatNumber
        website
        phone
        firstName
        lastName
        contactEmail
        companyEmail
        contactPhone
        line01
        line02
        city
        state
        postalCode
        country
        currency
        paymentTerms
        taxType
        taxRate
        note
        bank
        iban
        bic
        accountName
        commercialName
        supplierCreditorAccount
        supplierType
        individualType
        isArchived
        purchase {
          items {
            id
            tenantId
            activeFlag
            quoteId
            supplierId
            recapCostlineId
            quoteName
            projectName
            supplierName
            recapCostlineItem
            recapCostlineItem_fr
            provisionalTotal
            invoiceTotal
            taxAmount
            purchaseInvoiceDueDate
            purchaseArchivedDate
            purchasePaidDate
            supplierCreditorAccount
            purchaseOrderId
            poAvailable
            invoiceAvailable
            paymentStatus
            purchaseType
            supplierType
            invoiceKey
            _version
            _deleted
            _lastChangedAt
            createdOn
            updatedOn
          }
          nextToken
          startedAt
        }
        _version
        _deleted
        _lastChangedAt
        createdOn
        updatedOn
      }
      nextToken
      startedAt
    }
  }
`;
export const purchasesByTenantId = /* GraphQL */ `
  query PurchasesByTenantId(
    $tenantId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelPurchaseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    purchasesByTenantId(
      tenantId: $tenantId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenantId
        activeFlag
        quoteId
        supplierId
        recapCostlineId
        quoteName
        projectName
        supplierName
        recapCostlineItem
        recapCostlineItem_fr
        provisionalTotal
        invoiceTotal
        taxAmount
        purchaseInvoiceDueDate
        purchaseArchivedDate
        purchasePaidDate
        supplierCreditorAccount
        purchaseOrderId
        poAvailable
        invoiceAvailable
        paymentStatus
        purchaseType
        supplierType
        invoiceKey
        invoiceDocuments {
          bucket
          region
          key
          identityId
        }
        _version
        _deleted
        _lastChangedAt
        createdOn
        updatedOn
      }
      nextToken
      startedAt
    }
  }
`;
export const purchasesBySupplierId = /* GraphQL */ `
  query PurchasesBySupplierId(
    $supplierId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelPurchaseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    purchasesBySupplierId(
      supplierId: $supplierId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenantId
        activeFlag
        quoteId
        supplierId
        recapCostlineId
        quoteName
        projectName
        supplierName
        recapCostlineItem
        recapCostlineItem_fr
        provisionalTotal
        invoiceTotal
        taxAmount
        purchaseInvoiceDueDate
        purchaseArchivedDate
        purchasePaidDate
        supplierCreditorAccount
        purchaseOrderId
        poAvailable
        invoiceAvailable
        paymentStatus
        purchaseType
        supplierType
        invoiceKey
        invoiceDocuments {
          bucket
          region
          key
          identityId
        }
        _version
        _deleted
        _lastChangedAt
        createdOn
        updatedOn
      }
      nextToken
      startedAt
    }
  }
`;
export const purchasesByRecapCostlineId = /* GraphQL */ `
  query PurchasesByRecapCostlineId(
    $recapCostlineId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelPurchaseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    purchasesByRecapCostlineId(
      recapCostlineId: $recapCostlineId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenantId
        activeFlag
        quoteId
        supplierId
        recapCostlineId
        quoteName
        projectName
        supplierName
        recapCostlineItem
        recapCostlineItem_fr
        provisionalTotal
        invoiceTotal
        taxAmount
        purchaseInvoiceDueDate
        purchaseArchivedDate
        purchasePaidDate
        supplierCreditorAccount
        purchaseOrderId
        poAvailable
        invoiceAvailable
        paymentStatus
        purchaseType
        supplierType
        invoiceKey
        invoiceDocuments {
          bucket
          region
          key
          identityId
        }
        _version
        _deleted
        _lastChangedAt
        createdOn
        updatedOn
      }
      nextToken
      startedAt
    }
  }
`;
export const purchaseOrdersByTenantId = /* GraphQL */ `
  query PurchaseOrdersByTenantId(
    $tenantId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelPurchaseOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    purchaseOrdersByTenantId(
      tenantId: $tenantId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenantId
        activeFlag
        purchaseOrderNumber
        quoteId
        supplierId
        recapCostlineId
        costlineName
        costlineName_fr
        projectId
        poAvailable
        supplierName
        supplierTerms
        quantity
        number
        rate
        provisionalTotal
        taxRate
        deliveryDate
        deliveryAddress
        comments
        _version
        _deleted
        _lastChangedAt
        createdOn
        updatedOn
      }
      nextToken
      startedAt
    }
  }
`;
export const clientsByTenantId = /* GraphQL */ `
  query ClientsByTenantId(
    $tenantId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelClientsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    clientsByTenantId(
      tenantId: $tenantId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        email
        tenantId
        offlineIds
        activeFlag
        projects {
          items {
            id
            name
            tenantId
            freelancers
            childFreelancers
            offlineIds
            parentProjectId
            parentClientId
            activeFlag
            type
            projectType
            parentCompanyId
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const projectsByClientId = /* GraphQL */ `
  query ProjectsByClientId(
    $parentClientId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelProjectsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    projectsByClientId(
      parentClientId: $parentClientId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        tenantId
        freelancers
        childFreelancers
        offlineIds
        parentProjectId
        parentClientId
        activeFlag
        type
        projectType
        parentCompanyId
        childProjects {
          items {
            id
            name
            tenantId
            freelancers
            childFreelancers
            offlineIds
            parentProjectId
            parentClientId
            activeFlag
            type
            projectType
            parentCompanyId
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
        quotes {
          items {
            id
            name
            tenantId
            quoteType
            childFreelancers
            offlineIds
            activeFlag
            type
            parentProjectId
            billLocation
            marginPercentage
            overheadPercentage
            exchangeRate
            allowInternational
            freelancers
            parentCompanyId
            maximizeMinimize
            clientName
            projectName
            agency
            agencyRepresentative
            director
            executiveProducer
            lineProducer
            numberOfShootingDays
            notes
            introduction
            shooting
            prep
            shootingCountry
            prelight
            casting
            crew
            buyouts
            locations
            studio
            artDepartment
            wardrobe
            equipment
            travel
            accommodation
            editing
            imagePostproduction
            soundPostproduction
            deliverables
            insurance
            quoteGuidelines
            excluded
            paymentTerms
            miscellaneous
            installment1Percentage
            installment1Date
            installment2Percentage
            installment2Date
            balancePercentage
            balanceDate
            isStarred
            isChecked
            recapInfoComments
            contact
            advertiserJobID
            brand
            jobName
            agencyJobID
            product
            advertiser
            productionJobID
            advertiserAddress
            productionCompany
            productionContact
            vfxCo
            vfxProducer
            editorialCo
            editorialProducer
            musicCo
            musicProducer
            agencyProducer
            agencyCreativeTeam
            prepDays
            buildAndStrikeDays
            preLight
            stageDays
            locationDays
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const projectsByParentProjectId = /* GraphQL */ `
  query ProjectsByParentProjectId(
    $parentProjectId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelProjectsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    projectsByParentProjectId(
      parentProjectId: $parentProjectId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        tenantId
        freelancers
        childFreelancers
        offlineIds
        parentProjectId
        parentClientId
        activeFlag
        type
        projectType
        parentCompanyId
        childProjects {
          items {
            id
            name
            tenantId
            freelancers
            childFreelancers
            offlineIds
            parentProjectId
            parentClientId
            activeFlag
            type
            projectType
            parentCompanyId
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
        quotes {
          items {
            id
            name
            tenantId
            quoteType
            childFreelancers
            offlineIds
            activeFlag
            type
            parentProjectId
            billLocation
            marginPercentage
            overheadPercentage
            exchangeRate
            allowInternational
            freelancers
            parentCompanyId
            maximizeMinimize
            clientName
            projectName
            agency
            agencyRepresentative
            director
            executiveProducer
            lineProducer
            numberOfShootingDays
            notes
            introduction
            shooting
            prep
            shootingCountry
            prelight
            casting
            crew
            buyouts
            locations
            studio
            artDepartment
            wardrobe
            equipment
            travel
            accommodation
            editing
            imagePostproduction
            soundPostproduction
            deliverables
            insurance
            quoteGuidelines
            excluded
            paymentTerms
            miscellaneous
            installment1Percentage
            installment1Date
            installment2Percentage
            installment2Date
            balancePercentage
            balanceDate
            isStarred
            isChecked
            recapInfoComments
            contact
            advertiserJobID
            brand
            jobName
            agencyJobID
            product
            advertiser
            productionJobID
            advertiserAddress
            productionCompany
            productionContact
            vfxCo
            vfxProducer
            editorialCo
            editorialProducer
            musicCo
            musicProducer
            agencyProducer
            agencyCreativeTeam
            prepDays
            buildAndStrikeDays
            preLight
            stageDays
            locationDays
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const projectsByTenantId = /* GraphQL */ `
  query ProjectsByTenantId(
    $tenantId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelProjectsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    projectsByTenantId(
      tenantId: $tenantId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        tenantId
        freelancers
        childFreelancers
        offlineIds
        parentProjectId
        parentClientId
        activeFlag
        type
        projectType
        parentCompanyId
        childProjects {
          items {
            id
            name
            tenantId
            freelancers
            childFreelancers
            offlineIds
            parentProjectId
            parentClientId
            activeFlag
            type
            projectType
            parentCompanyId
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
        quotes {
          items {
            id
            name
            tenantId
            quoteType
            childFreelancers
            offlineIds
            activeFlag
            type
            parentProjectId
            billLocation
            marginPercentage
            overheadPercentage
            exchangeRate
            allowInternational
            freelancers
            parentCompanyId
            maximizeMinimize
            clientName
            projectName
            agency
            agencyRepresentative
            director
            executiveProducer
            lineProducer
            numberOfShootingDays
            notes
            introduction
            shooting
            prep
            shootingCountry
            prelight
            casting
            crew
            buyouts
            locations
            studio
            artDepartment
            wardrobe
            equipment
            travel
            accommodation
            editing
            imagePostproduction
            soundPostproduction
            deliverables
            insurance
            quoteGuidelines
            excluded
            paymentTerms
            miscellaneous
            installment1Percentage
            installment1Date
            installment2Percentage
            installment2Date
            balancePercentage
            balanceDate
            isStarred
            isChecked
            recapInfoComments
            contact
            advertiserJobID
            brand
            jobName
            agencyJobID
            product
            advertiser
            productionJobID
            advertiserAddress
            productionCompany
            productionContact
            vfxCo
            vfxProducer
            editorialCo
            editorialProducer
            musicCo
            musicProducer
            agencyProducer
            agencyCreativeTeam
            prepDays
            buildAndStrikeDays
            preLight
            stageDays
            locationDays
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const proposalsByQuoteId = /* GraphQL */ `
  query ProposalsByQuoteId(
    $quoteId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelProposalsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    proposalsByQuoteId(
      quoteId: $quoteId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenantId
        activeFlag
        quoteId
        clientId
        status
        noofInvoices
        quoteName
        projectName
        clientTaxType
        clientName
        contactName
        clientEmail
        clientAddress
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        paymentTerms
        total
        clientNote
        isDetailed
        bankProfileNumber
        proposalsBankProfileName
        proposalsBank
        proposalsIban
        proposalsBic
        proposalsAccountName
        drafts {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
        }
        quote {
          id
          name
          tenantId
          quoteType
          childFreelancers
          offlineIds
          activeFlag
          type
          parentProjectId
          billLocation
          marginPercentage
          overheadPercentage
          exchangeRate
          allowInternational
          freelancers
          parentCompanyId
          maximizeMinimize
          clientName
          projectName
          agency
          agencyRepresentative
          director
          executiveProducer
          lineProducer
          numberOfShootingDays
          notes
          introduction
          shooting
          prep
          shootingCountry
          prelight
          casting
          crew
          buyouts
          locations
          studio
          artDepartment
          wardrobe
          equipment
          travel
          accommodation
          editing
          imagePostproduction
          soundPostproduction
          deliverables
          insurance
          quoteGuidelines
          excluded
          paymentTerms
          miscellaneous
          installment1Percentage
          installment1Date
          installment2Percentage
          installment2Date
          balancePercentage
          balanceDate
          isStarred
          isChecked
          recapInfoComments
          contact
          discount {
            totalDiscount
            totalAfterDiscount
            totalDiscountOnMargin
            totalDiscountOnMarginPercentage
            totalDiscountPercentage
          }
          advertiserJobID
          brand
          jobName
          agencyJobID
          product
          advertiser
          productionJobID
          advertiserAddress
          productionCompany
          productionContact
          vfxCo
          vfxProducer
          editorialCo
          editorialProducer
          musicCo
          musicProducer
          agencyProducer
          agencyCreativeTeam
          prepDays
          buildAndStrikeDays
          preLight
          stageDays
          locationDays
          recapInfo {
            nextToken
            startedAt
          }
          quoteInfo {
            nextToken
            startedAt
          }
          proposals {
            nextToken
            startedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        invoices {
          items {
            id
            tenantId
            proposalId
            activeFlag
            originalInvoiceId
            creditInvoiceGenerated
            archivedDate
            paidDate
            paymentStatus
            quoteName
            projectName
            clientId
            clientName
            contactName
            clientTaxType
            clientEmail
            clientAddress
            clientIdNumber
            clientVatNumber
            clientCurrency
            clientTaxRate
            title
            invoiceNumber
            poNumber
            invoiceAmountPercentage
            amount
            amountAfterTax
            taxAmount
            balancePercentage
            balanceAmount
            clientNote
            isDetailed
            bankProfileNumber
            invoicesBankProfileName
            invoicesBank
            invoicesIban
            invoicesBic
            invoicesAccountName
            invoiceDate
            invoiceDueDate
            description
            creditComments
            invoiceType
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const proposalsByTenantId = /* GraphQL */ `
  query ProposalsByTenantId(
    $tenantId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelProposalsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    proposalsByTenantId(
      tenantId: $tenantId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenantId
        activeFlag
        quoteId
        clientId
        status
        noofInvoices
        quoteName
        projectName
        clientTaxType
        clientName
        contactName
        clientEmail
        clientAddress
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        paymentTerms
        total
        clientNote
        isDetailed
        bankProfileNumber
        proposalsBankProfileName
        proposalsBank
        proposalsIban
        proposalsBic
        proposalsAccountName
        drafts {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
        }
        quote {
          id
          name
          tenantId
          quoteType
          childFreelancers
          offlineIds
          activeFlag
          type
          parentProjectId
          billLocation
          marginPercentage
          overheadPercentage
          exchangeRate
          allowInternational
          freelancers
          parentCompanyId
          maximizeMinimize
          clientName
          projectName
          agency
          agencyRepresentative
          director
          executiveProducer
          lineProducer
          numberOfShootingDays
          notes
          introduction
          shooting
          prep
          shootingCountry
          prelight
          casting
          crew
          buyouts
          locations
          studio
          artDepartment
          wardrobe
          equipment
          travel
          accommodation
          editing
          imagePostproduction
          soundPostproduction
          deliverables
          insurance
          quoteGuidelines
          excluded
          paymentTerms
          miscellaneous
          installment1Percentage
          installment1Date
          installment2Percentage
          installment2Date
          balancePercentage
          balanceDate
          isStarred
          isChecked
          recapInfoComments
          contact
          discount {
            totalDiscount
            totalAfterDiscount
            totalDiscountOnMargin
            totalDiscountOnMarginPercentage
            totalDiscountPercentage
          }
          advertiserJobID
          brand
          jobName
          agencyJobID
          product
          advertiser
          productionJobID
          advertiserAddress
          productionCompany
          productionContact
          vfxCo
          vfxProducer
          editorialCo
          editorialProducer
          musicCo
          musicProducer
          agencyProducer
          agencyCreativeTeam
          prepDays
          buildAndStrikeDays
          preLight
          stageDays
          locationDays
          recapInfo {
            nextToken
            startedAt
          }
          quoteInfo {
            nextToken
            startedAt
          }
          proposals {
            nextToken
            startedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        invoices {
          items {
            id
            tenantId
            proposalId
            activeFlag
            originalInvoiceId
            creditInvoiceGenerated
            archivedDate
            paidDate
            paymentStatus
            quoteName
            projectName
            clientId
            clientName
            contactName
            clientTaxType
            clientEmail
            clientAddress
            clientIdNumber
            clientVatNumber
            clientCurrency
            clientTaxRate
            title
            invoiceNumber
            poNumber
            invoiceAmountPercentage
            amount
            amountAfterTax
            taxAmount
            balancePercentage
            balanceAmount
            clientNote
            isDetailed
            bankProfileNumber
            invoicesBankProfileName
            invoicesBank
            invoicesIban
            invoicesBic
            invoicesAccountName
            invoiceDate
            invoiceDueDate
            description
            creditComments
            invoiceType
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const invoicesByContactId = /* GraphQL */ `
  query InvoicesByContactId(
    $clientId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelInvoicesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invoicesByContactId(
      clientId: $clientId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenantId
        proposalId
        activeFlag
        originalInvoiceId
        creditInvoiceGenerated
        archivedDate
        paidDate
        paymentStatus
        quoteName
        projectName
        clientId
        clientName
        contactName
        clientTaxType
        clientEmail
        clientAddress
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        title
        invoiceNumber
        poNumber
        invoiceAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        clientNote
        isDetailed
        bankProfileNumber
        invoicesBankProfileName
        invoicesBank
        invoicesIban
        invoicesBic
        invoicesAccountName
        invoiceDate
        invoiceDueDate
        description
        creditComments
        invoiceType
        proposalsDraft {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
        }
        proposals {
          id
          tenantId
          activeFlag
          quoteId
          clientId
          status
          noofInvoices
          quoteName
          projectName
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          drafts {
            generated
            poNumber
            proposalAmountPercentage
            amount
            amountAfterTax
            taxAmount
            balancePercentage
            balanceAmount
            invoiceId
            invoiceDate
            invoiceDueDate
            description
            readyStatus
          }
          quote {
            id
            name
            tenantId
            quoteType
            childFreelancers
            offlineIds
            activeFlag
            type
            parentProjectId
            billLocation
            marginPercentage
            overheadPercentage
            exchangeRate
            allowInternational
            freelancers
            parentCompanyId
            maximizeMinimize
            clientName
            projectName
            agency
            agencyRepresentative
            director
            executiveProducer
            lineProducer
            numberOfShootingDays
            notes
            introduction
            shooting
            prep
            shootingCountry
            prelight
            casting
            crew
            buyouts
            locations
            studio
            artDepartment
            wardrobe
            equipment
            travel
            accommodation
            editing
            imagePostproduction
            soundPostproduction
            deliverables
            insurance
            quoteGuidelines
            excluded
            paymentTerms
            miscellaneous
            installment1Percentage
            installment1Date
            installment2Percentage
            installment2Date
            balancePercentage
            balanceDate
            isStarred
            isChecked
            recapInfoComments
            contact
            advertiserJobID
            brand
            jobName
            agencyJobID
            product
            advertiser
            productionJobID
            advertiserAddress
            productionCompany
            productionContact
            vfxCo
            vfxProducer
            editorialCo
            editorialProducer
            musicCo
            musicProducer
            agencyProducer
            agencyCreativeTeam
            prepDays
            buildAndStrikeDays
            preLight
            stageDays
            locationDays
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          invoices {
            nextToken
            startedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const invoicesByProposalId = /* GraphQL */ `
  query InvoicesByProposalId(
    $proposalId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelInvoicesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invoicesByProposalId(
      proposalId: $proposalId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenantId
        proposalId
        activeFlag
        originalInvoiceId
        creditInvoiceGenerated
        archivedDate
        paidDate
        paymentStatus
        quoteName
        projectName
        clientId
        clientName
        contactName
        clientTaxType
        clientEmail
        clientAddress
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        title
        invoiceNumber
        poNumber
        invoiceAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        clientNote
        isDetailed
        bankProfileNumber
        invoicesBankProfileName
        invoicesBank
        invoicesIban
        invoicesBic
        invoicesAccountName
        invoiceDate
        invoiceDueDate
        description
        creditComments
        invoiceType
        proposalsDraft {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
        }
        proposals {
          id
          tenantId
          activeFlag
          quoteId
          clientId
          status
          noofInvoices
          quoteName
          projectName
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          drafts {
            generated
            poNumber
            proposalAmountPercentage
            amount
            amountAfterTax
            taxAmount
            balancePercentage
            balanceAmount
            invoiceId
            invoiceDate
            invoiceDueDate
            description
            readyStatus
          }
          quote {
            id
            name
            tenantId
            quoteType
            childFreelancers
            offlineIds
            activeFlag
            type
            parentProjectId
            billLocation
            marginPercentage
            overheadPercentage
            exchangeRate
            allowInternational
            freelancers
            parentCompanyId
            maximizeMinimize
            clientName
            projectName
            agency
            agencyRepresentative
            director
            executiveProducer
            lineProducer
            numberOfShootingDays
            notes
            introduction
            shooting
            prep
            shootingCountry
            prelight
            casting
            crew
            buyouts
            locations
            studio
            artDepartment
            wardrobe
            equipment
            travel
            accommodation
            editing
            imagePostproduction
            soundPostproduction
            deliverables
            insurance
            quoteGuidelines
            excluded
            paymentTerms
            miscellaneous
            installment1Percentage
            installment1Date
            installment2Percentage
            installment2Date
            balancePercentage
            balanceDate
            isStarred
            isChecked
            recapInfoComments
            contact
            advertiserJobID
            brand
            jobName
            agencyJobID
            product
            advertiser
            productionJobID
            advertiserAddress
            productionCompany
            productionContact
            vfxCo
            vfxProducer
            editorialCo
            editorialProducer
            musicCo
            musicProducer
            agencyProducer
            agencyCreativeTeam
            prepDays
            buildAndStrikeDays
            preLight
            stageDays
            locationDays
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          invoices {
            nextToken
            startedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const invoicesByTenantId = /* GraphQL */ `
  query InvoicesByTenantId(
    $tenantId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelInvoicesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invoicesByTenantId(
      tenantId: $tenantId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenantId
        proposalId
        activeFlag
        originalInvoiceId
        creditInvoiceGenerated
        archivedDate
        paidDate
        paymentStatus
        quoteName
        projectName
        clientId
        clientName
        contactName
        clientTaxType
        clientEmail
        clientAddress
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        title
        invoiceNumber
        poNumber
        invoiceAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        clientNote
        isDetailed
        bankProfileNumber
        invoicesBankProfileName
        invoicesBank
        invoicesIban
        invoicesBic
        invoicesAccountName
        invoiceDate
        invoiceDueDate
        description
        creditComments
        invoiceType
        proposalsDraft {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
        }
        proposals {
          id
          tenantId
          activeFlag
          quoteId
          clientId
          status
          noofInvoices
          quoteName
          projectName
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          drafts {
            generated
            poNumber
            proposalAmountPercentage
            amount
            amountAfterTax
            taxAmount
            balancePercentage
            balanceAmount
            invoiceId
            invoiceDate
            invoiceDueDate
            description
            readyStatus
          }
          quote {
            id
            name
            tenantId
            quoteType
            childFreelancers
            offlineIds
            activeFlag
            type
            parentProjectId
            billLocation
            marginPercentage
            overheadPercentage
            exchangeRate
            allowInternational
            freelancers
            parentCompanyId
            maximizeMinimize
            clientName
            projectName
            agency
            agencyRepresentative
            director
            executiveProducer
            lineProducer
            numberOfShootingDays
            notes
            introduction
            shooting
            prep
            shootingCountry
            prelight
            casting
            crew
            buyouts
            locations
            studio
            artDepartment
            wardrobe
            equipment
            travel
            accommodation
            editing
            imagePostproduction
            soundPostproduction
            deliverables
            insurance
            quoteGuidelines
            excluded
            paymentTerms
            miscellaneous
            installment1Percentage
            installment1Date
            installment2Percentage
            installment2Date
            balancePercentage
            balanceDate
            isStarred
            isChecked
            recapInfoComments
            contact
            advertiserJobID
            brand
            jobName
            agencyJobID
            product
            advertiser
            productionJobID
            advertiserAddress
            productionCompany
            productionContact
            vfxCo
            vfxProducer
            editorialCo
            editorialProducer
            musicCo
            musicProducer
            agencyProducer
            agencyCreativeTeam
            prepDays
            buildAndStrikeDays
            preLight
            stageDays
            locationDays
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          invoices {
            nextToken
            startedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const quotesByParentProjectId = /* GraphQL */ `
  query QuotesByParentProjectId(
    $parentProjectId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelQuoteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    quotesByParentProjectId(
      parentProjectId: $parentProjectId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        tenantId
        quoteType
        childFreelancers
        offlineIds
        activeFlag
        type
        parentProjectId
        billLocation
        marginPercentage
        overheadPercentage
        exchangeRate
        allowInternational
        freelancers
        parentCompanyId
        maximizeMinimize
        clientName
        projectName
        agency
        agencyRepresentative
        director
        executiveProducer
        lineProducer
        numberOfShootingDays
        notes
        introduction
        shooting
        prep
        shootingCountry
        prelight
        casting
        crew
        buyouts
        locations
        studio
        artDepartment
        wardrobe
        equipment
        travel
        accommodation
        editing
        imagePostproduction
        soundPostproduction
        deliverables
        insurance
        quoteGuidelines
        excluded
        paymentTerms
        miscellaneous
        installment1Percentage
        installment1Date
        installment2Percentage
        installment2Date
        balancePercentage
        balanceDate
        isStarred
        isChecked
        recapInfoComments
        contact
        discount {
          totalDiscount
          totalAfterDiscount
          totalDiscountOnMargin
          totalDiscountOnMarginPercentage
          totalDiscountPercentage
        }
        advertiserJobID
        brand
        jobName
        agencyJobID
        product
        advertiser
        productionJobID
        advertiserAddress
        productionCompany
        productionContact
        vfxCo
        vfxProducer
        editorialCo
        editorialProducer
        musicCo
        musicProducer
        agencyProducer
        agencyCreativeTeam
        prepDays
        buildAndStrikeDays
        preLight
        stageDays
        locationDays
        recapInfo {
          items {
            id
            quoteId
            tenantId
            freelancers
            childFreelancers
            offlineIds
            activeFlag
            uuid
            categoryId
            category
            category_fr
            categoryPrefix
            subCategoryId
            subCategory
            subCategory_fr
            subCategoryPrefix
            subCategorySuffix
            tableRowIndex
            item
            item_fr
            isInternational
            editable
            costLineType
            costLineLabel
            language
            number
            rate
            exchangeEnabled
            exchangeRate
            rateInEuros
            quantity
            total
            totalMargin
            payrollTaxEnabled
            payrollTaxType
            isCustomCostLine
            referenceCostLineUuid
            provisionalTotal
            provisionalPayrollTaxEnabled
            provisionalPayrollTaxType
            actualTotal
            actualPayrollTaxEnabled
            actualPayrollTaxType
            purchaseTotal
            supplierStatus
            supplierId
            paymentStatus
            purchaseId
            comments
            invoiceId
            invoiceAvailable
            poAvailable
            purchaseOrderId
            _version
            _deleted
            _lastChangedAt
            createdAt
            updatedAt
          }
          nextToken
          startedAt
        }
        quoteInfo {
          items {
            id
            quoteId
            tenantId
            freelancers
            childFreelancers
            offlineIds
            activeFlag
            agentCommission
            agentCommissionPercentage
            allowMarginAndOverheadPercentageGlobalUpdate
            language
            category
            categoryId
            categoryPrefix
            category_fr
            costLineLabel
            costLineType
            editable
            exchangeEnabled
            exchangeRate
            tableRowIndex
            isInternational
            isVisible
            item
            item_fr
            margin
            marginPercentage
            number
            overhead
            overheadPercentage
            overtimeHours
            overtimeHoursCost
            payrollTaxEnabled
            payrollTaxType
            quantity
            rate
            rateInEuros
            subCategory
            subCategoryId
            subCategoryPrefix
            subCategorySuffix
            subCategory_fr
            total
            totalHeading
            totalMargin
            unit
            smg
            _version
            _deleted
            _lastChangedAt
            createdAt
            updatedAt
          }
          nextToken
          startedAt
        }
        proposals {
          items {
            id
            tenantId
            activeFlag
            quoteId
            clientId
            status
            noofInvoices
            quoteName
            projectName
            clientTaxType
            clientName
            contactName
            clientEmail
            clientAddress
            clientIdNumber
            clientVatNumber
            clientCurrency
            clientTaxRate
            paymentTerms
            total
            clientNote
            isDetailed
            bankProfileNumber
            proposalsBankProfileName
            proposalsBank
            proposalsIban
            proposalsBic
            proposalsAccountName
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const quotesByTenantId = /* GraphQL */ `
  query QuotesByTenantId(
    $tenantId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelQuoteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    quotesByTenantId(
      tenantId: $tenantId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        tenantId
        quoteType
        childFreelancers
        offlineIds
        activeFlag
        type
        parentProjectId
        billLocation
        marginPercentage
        overheadPercentage
        exchangeRate
        allowInternational
        freelancers
        parentCompanyId
        maximizeMinimize
        clientName
        projectName
        agency
        agencyRepresentative
        director
        executiveProducer
        lineProducer
        numberOfShootingDays
        notes
        introduction
        shooting
        prep
        shootingCountry
        prelight
        casting
        crew
        buyouts
        locations
        studio
        artDepartment
        wardrobe
        equipment
        travel
        accommodation
        editing
        imagePostproduction
        soundPostproduction
        deliverables
        insurance
        quoteGuidelines
        excluded
        paymentTerms
        miscellaneous
        installment1Percentage
        installment1Date
        installment2Percentage
        installment2Date
        balancePercentage
        balanceDate
        isStarred
        isChecked
        recapInfoComments
        contact
        discount {
          totalDiscount
          totalAfterDiscount
          totalDiscountOnMargin
          totalDiscountOnMarginPercentage
          totalDiscountPercentage
        }
        advertiserJobID
        brand
        jobName
        agencyJobID
        product
        advertiser
        productionJobID
        advertiserAddress
        productionCompany
        productionContact
        vfxCo
        vfxProducer
        editorialCo
        editorialProducer
        musicCo
        musicProducer
        agencyProducer
        agencyCreativeTeam
        prepDays
        buildAndStrikeDays
        preLight
        stageDays
        locationDays
        recapInfo {
          items {
            id
            quoteId
            tenantId
            freelancers
            childFreelancers
            offlineIds
            activeFlag
            uuid
            categoryId
            category
            category_fr
            categoryPrefix
            subCategoryId
            subCategory
            subCategory_fr
            subCategoryPrefix
            subCategorySuffix
            tableRowIndex
            item
            item_fr
            isInternational
            editable
            costLineType
            costLineLabel
            language
            number
            rate
            exchangeEnabled
            exchangeRate
            rateInEuros
            quantity
            total
            totalMargin
            payrollTaxEnabled
            payrollTaxType
            isCustomCostLine
            referenceCostLineUuid
            provisionalTotal
            provisionalPayrollTaxEnabled
            provisionalPayrollTaxType
            actualTotal
            actualPayrollTaxEnabled
            actualPayrollTaxType
            purchaseTotal
            supplierStatus
            supplierId
            paymentStatus
            purchaseId
            comments
            invoiceId
            invoiceAvailable
            poAvailable
            purchaseOrderId
            _version
            _deleted
            _lastChangedAt
            createdAt
            updatedAt
          }
          nextToken
          startedAt
        }
        quoteInfo {
          items {
            id
            quoteId
            tenantId
            freelancers
            childFreelancers
            offlineIds
            activeFlag
            agentCommission
            agentCommissionPercentage
            allowMarginAndOverheadPercentageGlobalUpdate
            language
            category
            categoryId
            categoryPrefix
            category_fr
            costLineLabel
            costLineType
            editable
            exchangeEnabled
            exchangeRate
            tableRowIndex
            isInternational
            isVisible
            item
            item_fr
            margin
            marginPercentage
            number
            overhead
            overheadPercentage
            overtimeHours
            overtimeHoursCost
            payrollTaxEnabled
            payrollTaxType
            quantity
            rate
            rateInEuros
            subCategory
            subCategoryId
            subCategoryPrefix
            subCategorySuffix
            subCategory_fr
            total
            totalHeading
            totalMargin
            unit
            smg
            _version
            _deleted
            _lastChangedAt
            createdAt
            updatedAt
          }
          nextToken
          startedAt
        }
        proposals {
          items {
            id
            tenantId
            activeFlag
            quoteId
            clientId
            status
            noofInvoices
            quoteName
            projectName
            clientTaxType
            clientName
            contactName
            clientEmail
            clientAddress
            clientIdNumber
            clientVatNumber
            clientCurrency
            clientTaxRate
            paymentTerms
            total
            clientNote
            isDetailed
            bankProfileNumber
            proposalsBankProfileName
            proposalsBank
            proposalsIban
            proposalsBic
            proposalsAccountName
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const quoteInfoByQuoteId = /* GraphQL */ `
  query QuoteInfoByQuoteId(
    $quoteId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelQuoteInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    quoteInfoByQuoteId(
      quoteId: $quoteId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        quoteId
        tenantId
        freelancers
        childFreelancers
        offlineIds
        activeFlag
        agentCommission
        agentCommissionPercentage
        allowMarginAndOverheadPercentageGlobalUpdate
        language
        category
        categoryId
        categoryPrefix
        category_fr
        costLineLabel
        costLineType
        editable
        exchangeEnabled
        exchangeRate
        tableRowIndex
        isInternational
        isVisible
        item
        item_fr
        margin
        marginPercentage
        number
        overhead
        overheadPercentage
        overtimeDetails {
          multiplier
          overtimeHours
        }
        overtimeHours
        overtimeHoursCost
        payrollTaxEnabled
        payrollTaxType
        quantity
        rate
        rateInEuros
        subCategory
        subCategoryId
        subCategoryPrefix
        subCategorySuffix
        subCategory_fr
        total
        totalHeading
        totalMargin
        unit
        smg
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const quoteInfoByTenantId = /* GraphQL */ `
  query QuoteInfoByTenantId(
    $tenantId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelQuoteInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    quoteInfoByTenantId(
      tenantId: $tenantId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        quoteId
        tenantId
        freelancers
        childFreelancers
        offlineIds
        activeFlag
        agentCommission
        agentCommissionPercentage
        allowMarginAndOverheadPercentageGlobalUpdate
        language
        category
        categoryId
        categoryPrefix
        category_fr
        costLineLabel
        costLineType
        editable
        exchangeEnabled
        exchangeRate
        tableRowIndex
        isInternational
        isVisible
        item
        item_fr
        margin
        marginPercentage
        number
        overhead
        overheadPercentage
        overtimeDetails {
          multiplier
          overtimeHours
        }
        overtimeHours
        overtimeHoursCost
        payrollTaxEnabled
        payrollTaxType
        quantity
        rate
        rateInEuros
        subCategory
        subCategoryId
        subCategoryPrefix
        subCategorySuffix
        subCategory_fr
        total
        totalHeading
        totalMargin
        unit
        smg
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const recapInfoInfoByQuoteId = /* GraphQL */ `
  query RecapInfoInfoByQuoteId(
    $quoteId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelRecapInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    recapInfoInfoByQuoteId(
      quoteId: $quoteId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        quoteId
        tenantId
        freelancers
        childFreelancers
        offlineIds
        activeFlag
        uuid
        categoryId
        category
        category_fr
        categoryPrefix
        subCategoryId
        subCategory
        subCategory_fr
        subCategoryPrefix
        subCategorySuffix
        tableRowIndex
        item
        item_fr
        isInternational
        editable
        costLineType
        costLineLabel
        language
        number
        rate
        exchangeEnabled
        exchangeRate
        rateInEuros
        quantity
        total
        totalMargin
        payrollTaxEnabled
        payrollTaxType
        isCustomCostLine
        referenceCostLineUuid
        provisionalTotal
        provisionalPayrollTaxEnabled
        provisionalPayrollTaxType
        actualTotal
        actualPayrollTaxEnabled
        actualPayrollTaxType
        purchaseTotal
        supplierStatus
        supplierId
        paymentStatus
        purchaseId
        comments
        invoiceId
        invoiceAvailable
        invoiceDocuments {
          bucket
          region
          key
          identityId
        }
        poAvailable
        purchaseOrderId
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const recapQuoteInfoByTenantId = /* GraphQL */ `
  query RecapQuoteInfoByTenantId(
    $tenantId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelRecapInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    recapQuoteInfoByTenantId(
      tenantId: $tenantId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        quoteId
        tenantId
        freelancers
        childFreelancers
        offlineIds
        activeFlag
        uuid
        categoryId
        category
        category_fr
        categoryPrefix
        subCategoryId
        subCategory
        subCategory_fr
        subCategoryPrefix
        subCategorySuffix
        tableRowIndex
        item
        item_fr
        isInternational
        editable
        costLineType
        costLineLabel
        language
        number
        rate
        exchangeEnabled
        exchangeRate
        rateInEuros
        quantity
        total
        totalMargin
        payrollTaxEnabled
        payrollTaxType
        isCustomCostLine
        referenceCostLineUuid
        provisionalTotal
        provisionalPayrollTaxEnabled
        provisionalPayrollTaxType
        actualTotal
        actualPayrollTaxEnabled
        actualPayrollTaxType
        purchaseTotal
        supplierStatus
        supplierId
        paymentStatus
        purchaseId
        comments
        invoiceId
        invoiceAvailable
        invoiceDocuments {
          bucket
          region
          key
          identityId
        }
        poAvailable
        purchaseOrderId
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
